/* =================================================================
   GBS BARRA CONVERSION BUILDER — JavaScript Module
   -----------------------------------------------------------------
   Three engine family pathways:
     • Barra 6 Cylinder (BA/BF/FG N/A & Turbo) — full cart flow
     • Barra V8                                 — contact required
     • Boss V8                                  — contact required

   CONFIGURATION: Edit the PRODUCTS object to update handles/titles.
   Variant IDs and prices are resolved from Shopify at runtime.
================================================================= */

(function () {
  'use strict';

  /* ================================================================
     VEHICLES
  ================================================================ */
  var VEHICLES = [
    {
      group: 'Ford',
      options: [
        { value: 'xd', label: 'XD Falcon' },
        { value: 'xe', label: 'XE Falcon' },
        { value: 'xf', label: 'XF Falcon' },
        { value: 'xg', label: 'XG Falcon' },
        { value: 'xh', label: 'XH Falcon' },
        { value: 'ea', label: 'EA Falcon' },
        { value: 'eb', label: 'EB Falcon' },
        { value: 'ed', label: 'ED Falcon' },
        { value: 'ef', label: 'EF Falcon' },
        { value: 'el', label: 'EL Falcon' },
        { value: 'au', label: 'AU Falcon' }
      ]
    },
    {
      group: 'Holden',
      options: [
        { value: 'vp', label: 'VP Commodore' },
        { value: 'vt', label: 'VT Commodore' },
        { value: 'vx', label: 'VX Commodore' },
        { value: 'vy', label: 'VY Commodore' }
      ]
    },
    {
      group: 'Nissan',
      options: [
        { value: 'nissan-gq-patrol', label: 'Nissan GQ Patrol' },
        { value: 'nissan-gu-patrol', label: 'Nissan GU Patrol' }
      ]
    }
  ];

  /* ================================================================
     6-CYLINDER ENGINES
  ================================================================ */
  var ENGINES = [
    { value: 'ba-na',    label: 'BA Barra N/A'   },
    { value: 'ba-turbo', label: 'BA Barra Turbo' },
    { value: 'bf-na',    label: 'BF Barra N/A'   },
    { value: 'bf-turbo', label: 'BF Barra Turbo' },
    { value: 'fg-na',    label: 'FG Barra N/A'   },
    { value: 'fg-turbo', label: 'FG Barra Turbo' },
    { value: 'fg-mk2',   label: 'FG Mk2 Barra'   }
  ];

  /* ================================================================
     6-CYLINDER TRANSMISSIONS
  ================================================================ */
  var TRANSMISSIONS = [
    { value: 'manual',         label: 'Manual'                       },
    { value: 'btr',            label: 'BTR Automatic'                },
    { value: 'zf',             label: 'ZF Automatic'                 },
    { value: 'powerglide',     label: 'Powerglide'                   },
    { value: 'th400',          label: 'TH400'                        },
    { value: 'trimatic',       label: 'Trimatic'                     },
    { value: 'other-auto',     label: 'Other Automatic'              },
    { value: 'aftermarket-tc', label: 'Aftermarket Trans Controller' }
  ];

  /* ================================================================
     V8 TRANSMISSIONS
  ================================================================ */
  var V8_TRANSMISSIONS = [
    { value: 'manual',         label: 'Manual'                       },
    { value: 'aod',            label: 'AOD Automatic'                },
    { value: 'c4',             label: 'C4 Automatic'                 },
    { value: 'c6',             label: 'C6 Automatic'                 },
    { value: 'th400',          label: 'TH400'                        },
    { value: 'powerglide',     label: 'Powerglide'                   },
    { value: 'trimatic',       label: 'Trimatic'                     },
    { value: 'other-auto',     label: 'Other Automatic'              },
    { value: 'aftermarket-tc', label: 'Aftermarket Trans Controller' }
  ];

  /* ================================================================
     SOHC COMPATIBILITY CONFIGURATION
     Central compatibility table — drives options at each SOHC step.
     Add new engines here; the step builders read from this object.
  ================================================================ */
  var SOHC_COMPAT = {
    'eb-falcon': { label: 'EB Falcon', years: '1991–1994', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','other'] },
    'ed-falcon': { label: 'ED Falcon', years: '1993–1996', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','other'] },
    'ef-falcon': { label: 'EF Falcon', years: '1994–1996', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','other'] },
    'el-falcon': { label: 'EL Falcon', years: '1996–1998', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','other'] },
    'au-falcon': { label: 'AU Falcon', years: '1998–2002', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','other'] },
    'other-sohc': { label: 'Other SOHC Setup', ecuGens: ['ba'], looms: ['standalone','integration'], transmissions: ['manual','btr','factory-auto','other','unsure'], requiresCustomInfo: true },
    'unsure-sohc': { label: 'Not Sure', requiresContact: true, ecuGens: [], looms: [], transmissions: [] }
  };

  var SOHC_TRANS_LABELS = {
    'manual':       'Factory Manual',
    'btr':          'BTR Automatic',
    'factory-auto': 'Factory Automatic',
    'other':        'Other Transmission',
    'unsure':       'Unsure'
  };

  /* ================================================================
     BOSS V8 VARIANTS
  ================================================================ */
  var BOSS_VARIANTS = [
    { value: '351w',    label: 'Boss 351 Windsor' },
    { value: '302w',    label: 'Boss 302 Windsor' },
    { value: '5.0-efi', label: 'Boss 5.0L EFI'   }
  ];

  /* ================================================================
     FEATURES
  ================================================================ */
  var FEATURES = [
    { value: 'ac',      label: 'Retain Air Conditioning' },
    { value: 'cruise',  label: 'Retain Cruise Control'   },
    { value: 'cluster', label: 'Retain Factory Cluster'  },
    { value: 'obd',     label: 'Extended OBDII Port'     }
  ];

  /* ================================================================
     VEHICLE → GROUP  /  ENGINE → SERIES  MAPPINGS
  ================================================================ */
  var VEHICLE_GROUP = {
    'xd': 'x-series',        'xe': 'x-series',   'xf': 'x-series',
    'xg': 'newer-ford',      'xh': 'newer-ford',
    'ea': 'newer-ford',      'eb': 'newer-ford',  'ed': 'newer-ford',
    'ef': 'newer-ford',      'el': 'newer-ford',  'au': 'newer-ford',
    'vp': 'commodore',       'vt': 'commodore',
    'vx': 'commodore',       'vy': 'commodore',
    'nissan-gq-patrol': 'patrol', 'nissan-gu-patrol': 'patrol'
  };

  var ENGINE_SERIES = {
    'ba-na': 'ba-bf', 'ba-turbo': 'ba-bf',
    'bf-na': 'ba-bf', 'bf-turbo': 'ba-bf',
    'fg-na': 'fg',    'fg-turbo': 'fg',
    'fg-mk2': 'fg-mk2'
  };

  /* ================================================================
     PRODUCT CATALOGUE  (6-cyl only; V8 products are contact-required)
  ================================================================ */
  var PRODUCTS = {
    standaloneHarness: {
      title:  'Barra Standalone Conversion Loom with Fuse Box',
      handle: 'standalone-barra-loom-with-fuse-box',
      badge:  'Conversion Harness'
    },
    integrationHarness: {
      title:  'Standalone Barra Loom without Fuse Box',
      handle: 'standalone-barra-loom',
      badge:  'Conversion Harness'
    },
    mailInEcu: {
      title:  'Barra ECU Unlock & PATS Removal Service',
      handle: 'barra-ecu-unlock',
      badge:  'ECU Service'
    },
    suppliedEcu: {
      title:  'Ford Barra Standalone ECU / PCM',
      handle: 'barra-standalone-ecu',
      badge:  'ECU Service'
    },
    canbarra: {
      title:  'CANbarra Module',
      handle: 'canbarra-module-by-can-solutions',
      badge:  'Required Add-on'
    },
    sohcHarnessStandalone: {
      title:  'SOHC Barra ECU Standalone Loom — Relay Box',
      handle: 'sohc-barra-ecu-standalone-loom-relay-box',
      badge:  'Conversion Harness'
    },
    sohcHarnessIntegration: {
      title:  'SOHC Barra ECU Standalone Loom — No Relay Box',
      handle: 'sohc-barra-ecu-standalone-loom-no-relay-box',
      badge:  'Conversion Harness'
    },
    /* ── BA/BF V8 — FUTURE (keys reserved, not yet wired to steps) ── */
    baV8Harness: {
      title:  'BA V8 Boss Conversion Loom',
      handle: 'ba-v8-boss-conversion-loom',
      badge:  'Conversion Harness'
    },
    bfV8Harness: {
      title:  'BF V8 Boss Conversion Loom',
      handle: 'bf-v8-boss-conversion-loom',
      badge:  'Conversion Harness'
    },
    /* ── Add-on products — create these in Shopify at the listed handle ── */
    aftermarketDash: {
      title:  'Aftermarket Dash Provision',
      handle: 'aftermarket-dash-provision',
      badge:  'Add-on'
    }
  };

  /* ================================================================
     DYNAMIC STEP SEQUENCES
     Set by buildStepSequence(family) before step 1 is rendered.
  ================================================================ */
  var ACTIVE_STEPS       = [];
  var ACTIVE_STATE_KEYS  = [];
  var ACTIVE_STEP_LABELS = [];
  var TOTAL_STEPS        = 0;

  function buildStepSequence(family) {
    if (family === 'barra-6cyl') {
      ACTIVE_STEPS = [
        { id: 1, title: 'Select Your Vehicle',        type: 'vehicle'                        },
        { id: 2, title: 'Select Your Engine',         type: 'single',  data: ENGINES         },
        { id: 3, title: 'Select Your Transmission',   type: 'single',  data: TRANSMISSIONS   },
        { id: 4, title: 'Choose Your Harness Style',  type: 'harness'                        },
        { id: 5, title: 'ECU',                        type: 'ecu'                            },
        { id: 6, title: 'What Features Do You Want?', type: 'features'                       }
      ];
      ACTIVE_STATE_KEYS  = ['vehicle', 'engine', 'transmission', 'harnessStyle', 'ecu', 'features'];
      ACTIVE_STEP_LABELS = ['Vehicle', 'Engine', 'Trans', 'Harness', 'ECU', 'Features'];
    } else if (family === 'barra-v8') {
      ACTIVE_STEPS = [
        { id: 1, title: 'Select Your Vehicle',        type: 'vehicle'                           },
        { id: 2, title: 'Select Your Transmission',   type: 'single',  data: V8_TRANSMISSIONS   },
        { id: 3, title: 'Choose Your Harness Style',  type: 'harness'                           },
        { id: 4, title: 'ECU Service',                type: 'ecu-service'                       },
        { id: 5, title: 'What Features Do You Want?', type: 'features-v8'                       }
      ];
      ACTIVE_STATE_KEYS  = ['vehicle', 'transmission', 'harnessStyle', 'ecu', 'features'];
      ACTIVE_STEP_LABELS = ['Vehicle', 'Trans', 'Harness', 'ECU', 'Features'];
    } else if (family === 'boss-v8') {
      ACTIVE_STEPS = [
        { id: 1, title: 'Select Your Vehicle',          type: 'vehicle'                           },
        { id: 2, title: 'Select Your Boss V8 Variant',  type: 'single',  data: BOSS_VARIANTS      },
        { id: 3, title: 'Select Your Transmission',     type: 'single',  data: V8_TRANSMISSIONS   },
        { id: 4, title: 'Choose Your Harness Style',    type: 'harness'                           },
        { id: 5, title: 'ECU Service',                  type: 'ecu-service'                       },
        { id: 6, title: 'What Features Do You Want?',   type: 'features-v8'                       }
      ];
      ACTIVE_STATE_KEYS  = ['vehicle', 'bossVariant', 'transmission', 'harnessStyle', 'ecu', 'features'];
      ACTIVE_STEP_LABELS = ['Vehicle', 'Variant', 'Trans', 'Harness', 'ECU', 'Features'];
    } else if (family === 'sohc-barra-ecu') {
      ACTIVE_STEPS = [
        { id: 1, title: 'Select Your SOHC Engine or Vehicle', type: 'sohc-engine'       },
        { id: 2, title: 'ECU Programming',                    type: 'sohc-ecu-info'     },
        { id: 3, title: 'ECU Generation',                     type: 'sohc-ecu-gen'      },
        { id: 4, title: 'Select Loom Setup',                  type: 'sohc-loom'         },
        { id: 5, title: 'Transmission',                       type: 'sohc-transmission' },
        { id: 6, title: 'Your Build Details',                 type: 'sohc-vehicle-info' }
      ];
      ACTIVE_STATE_KEYS  = ['sohcEngine', 'ecu', 'sohcEcuGen', 'harnessStyle', 'sohcTransmission', 'sohcVehicleInfo'];
      ACTIVE_STEP_LABELS = ['Engine', 'ECU', 'ECU Gen', 'Loom', 'Trans', 'Details'];
    }
    TOTAL_STEPS = ACTIVE_STEPS.length;
  }

  /* ================================================================
     STATE
  ================================================================ */
  var state = {
    engineFamily:     null,
    vehicle:          null,
    engine:           null,
    bossVariant:      null,
    transmission:     null,
    harnessStyle:     null,
    ecu:              null,
    sohcEngine:       null,
    sohcEcuGen:       null,
    sohcEcuInfo:      '',
    sohcTransmission: null,
    sohcVehicleInfo:  { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' },
    features:         [],
    clusterInfo:      { clusterType: '', notes: '' },
    canbarraInfo:     { vehicleMakeModel: '', year: '', originalEngine: '' },
    dashProvision:    null,
    dashModel:        ''
  };

  var activeStep   = 1;
  var cartItems    = [];
  var familyCardEl = null;

  var progressEl, stepsEl, resultsEl, restartEl;

  /* ================================================================
     INIT
  ================================================================ */
  function init() {
    progressEl = document.getElementById('gbsProgress');
    stepsEl    = document.getElementById('gbsSteps');
    resultsEl  = document.getElementById('gbsResults');
    restartEl  = document.getElementById('gbsRestart');
    if (!stepsEl) return;
    var rb = document.getElementById('gbsRestartBtn');
    if (rb) rb.addEventListener('click', reset);
    if (progressEl) progressEl.hidden = true;
    appendFamilyStep();
  }

  /* ================================================================
     PROGRESS BAR
  ================================================================ */
  function renderProgress() {
    if (!progressEl) return;
    var html = '<div class="gbsp__track">';
    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var done   = i < activeStep;
      var active = i === activeStep;
      var cls    = done ? 'is-done' : active ? 'is-active' : '';
      html += '<div class="gbsp__step ' + cls + '">';
      html += '<div class="gbsp__circle">' + (done ? '&#10003;' : i) + '</div>';
      html += '<span class="gbsp__label">' + ACTIVE_STEP_LABELS[i - 1] + '</span>';
      html += '</div>';
      if (i < TOTAL_STEPS) html += '<div class="gbsp__line' + (done ? ' is-done' : '') + '"></div>';
    }
    html += '</div>';
    progressEl.innerHTML = html;
  }

  /* ================================================================
     ENGINE FAMILY PRE-STEP
  ================================================================ */
  function appendFamilyStep() {
    var card = document.createElement('div');
    card.className = 'gbs-step gbs-step--family';
    card.id = 'gbsStepFamily';
    card.innerHTML =
      '<div class="gbs-step__header">' +
        '<span class="gbs-step__family-icon">&#9881;</span>' +
        '<h2 class="gbs-step__title">Select Your Engine or Conversion Type</h2>' +
      '</div>' +
      '<div class="gbs-step__body">' + buildEngineFamilyBody() + '</div>';
    stepsEl.appendChild(card);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { card.classList.add('is-visible'); });
    });
    bindFamilyListeners(card);
    familyCardEl = card;
  }

  function buildEngineFamilyBody() {
    var sel = function (v) { return state.engineFamily === v ? ' is-selected' : ''; };
    return (
      '<p class="gbs-ef__sub">Choose the engine or conversion type you are working with so we can show you the correct ECU, loom and integration options.</p>' +

      '<div class="gbs-ef__cards">' +

        '<button class="gbs-ef-card' + sel('barra-6cyl') + '" data-family="barra-6cyl" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge">&#10003; Available Now</span>' +
            '<h3 class="gbs-ef-card__title">Barra 6 Cylinder</h3>' +
            '<p class="gbs-ef-card__desc">BA, BF &amp; FG Barra inline-six engine conversion — N/A and Turbo. Full product range available to order directly.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>BA / BF / FG &amp; FG Mk2</li>' +
              '<li>Naturally Aspirated &amp; Turbo</li>' +
              '<li>Conversion harness &amp; ECU service</li>' +
              '<li>Add to cart in one click</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

        '<button class="gbs-ef-card gbs-ef-card--sohc' + sel('sohc-barra-ecu') + '" data-family="sohc-barra-ecu" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge">&#10003; Available Now</span>' +
            '<h3 class="gbs-ef-card__title">Barra ECU to SOHC Conversion</h3>' +
            '<p class="gbs-ef-card__desc">Run your existing Ford SOHC engine using a factory Barra PCM and purpose-built conversion loom. Modern ECU management without a Barra engine swap.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>EB / ED / EF / EL &amp; AU Falcon</li>' +
              '<li>Factory Barra PCM control</li>' +
              '<li>PCMTEC tuning &amp; full OBDII</li>' +
              '<li>Dedicated SOHC conversion loom</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

        '<button class="gbs-ef-card gbs-ef-card--contact' + sel('barra-v8') + '" data-family="barra-v8" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge gbs-ef-card__badge--contact">&#128233; Contact Required</span>' +
            '<h3 class="gbs-ef-card__title">Barra V8</h3>' +
            '<p class="gbs-ef-card__desc">V8 Barra conversion builds. Configure your build and contact us for a custom quote and build plan.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>Custom harness builds</li>' +
              '<li>Tailored to your build</li>' +
              '<li>Direct team consultation</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

        '<button class="gbs-ef-card gbs-ef-card--contact' + sel('boss-v8') + '" data-family="boss-v8" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge gbs-ef-card__badge--contact">&#128233; Contact Required</span>' +
            '<h3 class="gbs-ef-card__title">Boss V8</h3>' +
            '<p class="gbs-ef-card__desc">Ford Boss V8 conversion builds — 302, 351 Windsor and 5.0L EFI variants. Contact us for a custom quote.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>302 / 351 Windsor &amp; 5.0L EFI</li>' +
              '<li>Custom harness builds</li>' +
              '<li>Direct team consultation</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

      '</div>'
    );
  }

  function bindFamilyListeners(card) {
    card.querySelectorAll('.gbs-ef-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        onFamilySelect(card, btn.getAttribute('data-family'));
      });
    });
    var editBtn = card.querySelector('.gbs-step__edit-btn');
    if (editBtn) editBtn.addEventListener('click', editFamilyStep);
  }

  function onFamilySelect(card, family) {
    card.querySelectorAll('.gbs-ef-card').forEach(function (b) { b.classList.remove('is-selected'); });
    var sel = card.querySelector('[data-family="' + family + '"]');
    if (sel) sel.classList.add('is-selected');

    state.engineFamily = family;

    /* Remove any previously rendered numbered steps */
    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var el = document.getElementById('gbsStep' + s);
      if (el) el.remove();
    }
    if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.hidden = true; }
    if (restartEl) restartEl.hidden = true;

    setTimeout(function () {
      buildStepSequence(family);
      collapseFamilyStep(card, displayFamilyLabel(family));
      if (progressEl) progressEl.hidden = false;
      activeStep = 1;
      renderProgress();
      appendStep(1);
      setTimeout(function () {
        var next = document.getElementById('gbsStep1');
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 200);
    }, 320);
  }

  function collapseFamilyStep(card, labelText) {
    card.classList.add('is-complete');
    var body = card.querySelector('.gbs-step__body');
    if (!body) return;
    body.innerHTML =
      '<div class="gbs-step__summary">' +
        '<span class="gbs-step__summary-value">' + esc(labelText) + '</span>' +
        '<button class="gbs-step__edit-btn" type="button">Edit</button>' +
      '</div>';
    body.querySelector('.gbs-step__edit-btn').addEventListener('click', editFamilyStep);
  }

  function editFamilyStep() {
    /* Clear all state */
    state.engineFamily = null; state.vehicle = null; state.engine = null;
    state.bossVariant = null; state.transmission = null; state.harnessStyle = null;
    state.ecu = null; state.sohcEngine = null; state.sohcEcuGen = null; state.sohcEcuInfo = '';
    state.sohcTransmission = null;
    state.sohcVehicleInfo = { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' };
    state.features = [];
    state.clusterInfo  = { clusterType: '', notes: '' };
    state.canbarraInfo = { vehicleMakeModel: '', year: '', originalEngine: '' };
    state.dashProvision = null; state.dashModel = '';
    cartItems = [];

    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var el = document.getElementById('gbsStep' + s);
      if (el) el.remove();
    }
    ACTIVE_STEPS = []; ACTIVE_STATE_KEYS = []; ACTIVE_STEP_LABELS = []; TOTAL_STEPS = 0;
    activeStep = 1;

    if (progressEl) { progressEl.hidden = true; progressEl.innerHTML = ''; }
    if (resultsEl)  { resultsEl.innerHTML = ''; resultsEl.hidden = true; }
    if (restartEl)    restartEl.hidden = true;

    if (familyCardEl) {
      familyCardEl.classList.remove('is-complete');
      var body = familyCardEl.querySelector('.gbs-step__body');
      if (body) body.innerHTML = buildEngineFamilyBody();
      bindFamilyListeners(familyCardEl);
      familyCardEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ================================================================
     ENGINE TYPE SUB-STEP  (Barra 6 Cylinder only)
  ================================================================ */
  function appendEngineTypeStep() {
    var card = document.createElement('div');
    card.className = 'gbs-step gbs-step--engine-type';
    card.id = 'gbsStepEngineType';
    card.innerHTML =
      '<div class="gbs-step__header">' +
        '<span class="gbs-step__family-icon">&#9881;</span>' +
        '<h2 class="gbs-step__title">What engine are you running?</h2>' +
      '</div>' +
      '<div class="gbs-step__body">' + buildEngineTypeBody() + '</div>';
    stepsEl.appendChild(card);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { card.classList.add('is-visible'); });
    });
    bindEngineTypeListeners(card);
    engineTypeCardEl = card;
    setTimeout(function () { card.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 200);
  }

  function buildEngineTypeBody() {
    var sel = function (v) { return state.engineType === v ? ' is-selected' : ''; };
    return (
      '<p class="gbs-ef__sub">Choose the engine you are running. This determines the available products and configuration pathway for your conversion.</p>' +
      '<div class="gbs-ef__cards">' +

        '<button class="gbs-ef-card' + sel('barra') + '" data-engine-type="barra" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge">&#10003; Full Product Range</span>' +
            '<h3 class="gbs-ef-card__title">Barra Engine</h3>' +
            '<p class="gbs-ef-card__desc">Running a Barra inline-six engine. Full Barra conversion harness range available to order directly.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>BA / BF / FG &amp; FG Mk2</li>' +
              '<li>Naturally Aspirated &amp; Turbo</li>' +
              '<li>Full conversion harness range</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

        '<button class="gbs-ef-card gbs-ef-card--sohc' + sel('sohc') + '" data-engine-type="sohc" type="button">' +
          '<div class="gbs-ef-card__body">' +
            '<span class="gbs-ef-card__badge">&#9881; SOHC + Barra ECU</span>' +
            '<h3 class="gbs-ef-card__title">SOHC Engine (Running Barra ECU)</h3>' +
            '<p class="gbs-ef-card__desc">Running an SOHC engine controlled by a factory Barra PCM. Modern ECU management, PCMTEC tuning, and OBDII diagnostics while keeping your SOHC engine.</p>' +
            '<ul class="gbs-ef-card__list">' +
              '<li>Factory Barra PCM control</li>' +
              '<li>PCMTEC tuning support</li>' +
              '<li>Full OBDII diagnostics</li>' +
            '</ul>' +
          '</div>' +
          '<span class="gbs-ef-card__arrow">&#8594;</span>' +
        '</button>' +

      '</div>'
    );
  }

  function bindEngineTypeListeners(card) {
    card.querySelectorAll('[data-engine-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        onEngineTypeSelect(card, btn.getAttribute('data-engine-type'));
      });
    });
    var editBtn = card.querySelector('.gbs-step__edit-btn');
    if (editBtn) editBtn.addEventListener('click', editEngineTypeStep);
  }

  function onEngineTypeSelect(card, engineType) {
    card.querySelectorAll('[data-engine-type]').forEach(function (b) { b.classList.remove('is-selected'); });
    var sel = card.querySelector('[data-engine-type="' + engineType + '"]');
    if (sel) sel.classList.add('is-selected');

    state.engineType = engineType;

    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var el = document.getElementById('gbsStep' + s);
      if (el) el.remove();
    }
    if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.hidden = true; }
    if (restartEl) restartEl.hidden = true;

    var family = (engineType === 'sohc') ? 'sohc-barra-ecu' : 'barra-6cyl';
    setTimeout(function () {
      buildStepSequence(family);
      collapseEngineTypeStep(card, engineType === 'sohc' ? 'SOHC Engine (Running Barra ECU)' : 'Barra Engine');
      if (progressEl) progressEl.hidden = false;
      activeStep = 1;
      renderProgress();
      appendStep(1);
      setTimeout(function () {
        var next = document.getElementById('gbsStep1');
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 200);
    }, 320);
  }

  function collapseEngineTypeStep(card, labelText) {
    card.classList.add('is-complete');
    var body = card.querySelector('.gbs-step__body');
    if (!body) return;
    body.innerHTML =
      '<div class="gbs-step__summary">' +
        '<span class="gbs-step__summary-value">' + esc(labelText) + '</span>' +
        '<button class="gbs-step__edit-btn" type="button">Edit</button>' +
      '</div>';
    body.querySelector('.gbs-step__edit-btn').addEventListener('click', editEngineTypeStep);
  }

  function editEngineTypeStep() {
    state.engineType = null; state.vehicle = null; state.engine = null;
    state.transmission = null; state.harnessStyle = null;
    state.ecu = null; state.sohcEcuGen = null; state.sohcEcuInfo = '';
    state.sohcVehicleInfo = { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' };
    state.features = [];
    state.clusterInfo  = { clusterType: '', notes: '' };
    state.canbarraInfo = { vehicleMakeModel: '', year: '', originalEngine: '' };
    state.dashProvision = null; state.dashModel = '';
    cartItems = [];

    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var el = document.getElementById('gbsStep' + s);
      if (el) el.remove();
    }
    ACTIVE_STEPS = []; ACTIVE_STATE_KEYS = []; ACTIVE_STEP_LABELS = []; TOTAL_STEPS = 0;
    activeStep = 1;

    if (progressEl) { progressEl.hidden = true; progressEl.innerHTML = ''; }
    if (resultsEl)  { resultsEl.innerHTML = ''; resultsEl.hidden = true; }
    if (restartEl)    restartEl.hidden = true;

    if (engineTypeCardEl) {
      engineTypeCardEl.classList.remove('is-complete');
      var body = engineTypeCardEl.querySelector('.gbs-step__body');
      if (body) body.innerHTML = buildEngineTypeBody();
      bindEngineTypeListeners(engineTypeCardEl);
      engineTypeCardEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* ================================================================
     STEP RENDERING
  ================================================================ */
  function isTurboEngine() {
    return !!(state.engine && state.engine.indexOf('turbo') !== -1);
  }

  function appendStep(stepId) {
    var step = getStep(stepId);
    if (!step) return;
    var title = step.title;
    if (step.type === 'ecu' && isTurboEngine()) title = 'Turbo ECU &amp; Boost Control';
    var card = document.createElement('div');
    card.className = 'gbs-step';
    card.id = 'gbsStep' + stepId;
    card.setAttribute('data-step', stepId);
    card.innerHTML =
      '<div class="gbs-step__header">' +
        '<span class="gbs-step__num">' + stepId + '</span>' +
        '<h2 class="gbs-step__title">' + title + '</h2>' +
      '</div>' +
      '<div class="gbs-step__body">' + buildBody(step) + '</div>';
    stepsEl.appendChild(card);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { card.classList.add('is-visible'); });
    });
    bindListeners(card, stepId);
  }

  function buildBody(step) {
    var keyForStep = ACTIVE_STATE_KEYS[step.id - 1];
    switch (step.type) {
      case 'vehicle':           return buildVehicleBody();
      case 'single':            return buildSingleBody(step.data, keyForStep);
      case 'harness':           return buildHarnessStyleBody();
      case 'ecu':               return buildEcuBody();
      case 'ecu-service':       return buildEcuServiceBody();
      case 'sohc-engine':       return buildSohcEngineBody();
      case 'sohc-ecu-info':     return buildSohcEcuInfoBody();
      case 'sohc-ecu-service':  return buildSohcEcuServiceBody(); /* FUTURE: re-enable when ECU services available */
      case 'sohc-ecu-gen':      return buildSohcEcuGenBody();
      case 'sohc-loom':         return buildSohcLoomBody();
      case 'sohc-transmission': return buildSohcTransmissionBody();
      case 'sohc-vehicle-info': return buildSohcVehicleInfoBody();
      case 'features':          return buildFeaturesBody();
      case 'features-v8':       return buildFeaturesV8Body();
      default:                  return '';
    }
  }

  function buildVehicleBody() {
    var html = '';
    VEHICLES.forEach(function (group) {
      html += '<p class="gbs-step__group-label">' + esc(group.group) + '</p>';
      html += '<div class="gbs-step__options">';
      group.options.forEach(function (opt) { html += optBtn(opt, 'vehicle'); });
      html += '</div>';
    });
    html += '<p class="gbs-step__group-label">Other</p>';
    html += '<div class="gbs-step__options">';
    html += '<button class="gbs-opt gbs-other-vehicle-btn" data-key="vehicle" data-value="__other__" type="button" style="grid-column:1/-1">My vehicle isn\'t listed &hellip;</button>';
    html += '</div>';
    html += '<div class="gbs-other-vehicle" id="gbsOtherVehicle" hidden>';
    html +=   '<input class="gbs-other-vehicle__input" id="gbsOtherInput" type="text" placeholder="e.g. HQ Holden, Nissan Patrol, Celica…" autocomplete="off" />';
    html +=   '<button class="gbs-other-vehicle__confirm" id="gbsOtherConfirm" type="button">Confirm &#8594;</button>';
    html +=   '<p class="gbs-other-vehicle__hint">Type your vehicle and click Confirm to continue.</p>';
    html += '</div>';
    return html;
  }

  function buildSingleBody(list, key) {
    var html = '<div class="gbs-step__options">';
    list.forEach(function (opt) { html += optBtn(opt, key); });
    return html + '</div>';
  }

  /* Falcons from EA / XH onwards → integration harness is recommended */
  var FALCON_INTEGRATION_VEHICLES = ['xh','ea','eb','ed','ef','el','au'];
  function isFalconIntegration() {
    return FALCON_INTEGRATION_VEHICLES.indexOf(state.vehicle) !== -1;
  }

  /* Nissan Patrol → standalone harness with fuse box is required */
  function isPatrolVehicle() {
    return state.vehicle === 'nissan-gq-patrol' || state.vehicle === 'nissan-gu-patrol';
  }

  /* ── Step 4 (6-cyl): Harness Style ──────────────────────────── */
  function buildHarnessStyleBody() {
    var selSt      = state.harnessStyle === 'standalone'  ? ' is-selected' : '';
    var selIn      = state.harnessStyle === 'integration' ? ' is-selected' : '';
    var falconRec  = isFalconIntegration();
    var patrolVeh  = isPatrolVehicle();
    var stBadge, inBadge, hintText;
    if (patrolVeh) {
      stBadge   = '<span class="gbs-hs-card__badge gbs-hs-card__badge--patrol">&#11088; Recommended for Nissan Patrol</span>';
      inBadge   = '<span class="gbs-hs-card__no-badge"></span>';
      hintText  = 'The <strong>Standalone Harness with Fuse Box</strong> is required for Nissan Patrol conversions. The Patrol does not have a compatible factory fuse and relay layout — the standalone harness provides its own integrated fuse box and relay system for a clean, reliable install.';
    } else if (falconRec) {
      stBadge   = '<span class="gbs-hs-card__no-badge"></span>';
      inBadge   = '<span class="gbs-hs-card__badge">&#11088; Recommended for your Falcon</span>';
      hintText  = 'Based on your vehicle selection we recommend the <strong>Integration Harness</strong>. Falcon vehicles from EA and XH onwards already have a compatible relay and fuse layout, and the integration harness is purpose-built to work with it cleanly.';
    } else {
      stBadge   = '<span class="gbs-hs-card__badge">&#11088; Recommended</span>';
      inBadge   = '<span class="gbs-hs-card__no-badge"></span>';
      hintText  = 'If you\'re unsure, we recommend the <strong>Standalone Harness</strong>. It includes its own relay and fuse system and is designed to make installation significantly easier.';
    }
    return (
      '<p class="gbs-hs__sub">Select how you would like your Barra conversion harness to integrate with your vehicle.</p>' +

      '<div class="gbs-hs__cards">' +

        '<button class="gbs-hs-card' + selSt + '" data-key="harnessStyle" data-value="standalone" type="button">' +
          '<div class="gbs-hs-card__top">' +
            stBadge +
            '<span class="gbs-hs-card__circle"><span class="gbs-hs-card__tick">&#10003;</span></span>' +
          '</div>' +
          '<h3 class="gbs-hs-card__title">Standalone Harness</h3>' +
          '<p class="gbs-hs-card__desc">Our Standalone Harness includes its own integrated relay and fuse system, meaning it independently controls ignition power, starter trigger, fuel pump and thermo fans.</p>' +
          '<div class="gbs-hs-card__section">' +
            '<p class="gbs-hs-card__section-label">This harness controls:</p>' +
            '<ul class="gbs-hs-card__list">' +
              '<li>Ignition Power</li><li>Starter Trigger</li><li>Fuel Pump</li><li>Thermo Fans</li>' +
            '</ul>' +
          '</div>' +
          '<div class="gbs-hs-card__suited">' +
            '<p class="gbs-hs-card__section-label">Best suited for:</p>' +
            '<ul class="gbs-hs-card__list gbs-hs-card__list--muted">' +
              '<li>First-time Barra conversions</li><li>DIY installers</li><li>Non-Falcon builds</li>' +
            '</ul>' +
          '</div>' +
        '</button>' +

        '<button class="gbs-hs-card' + selIn + '" data-key="harnessStyle" data-value="integration" type="button">' +
          '<div class="gbs-hs-card__top">' +
            inBadge +
            '<span class="gbs-hs-card__circle"><span class="gbs-hs-card__tick">&#10003;</span></span>' +
          '</div>' +
          '<h3 class="gbs-hs-card__title">Integration Harness</h3>' +
          '<p class="gbs-hs-card__desc">Designed to utilise the vehicle\'s existing relay and fuse system. Ignition power, starter trigger, fuel pump and thermo fan circuits integrate into the existing electrical system.</p>' +
          '<div class="gbs-hs-card__suited">' +
            '<p class="gbs-hs-card__section-label">Best suited for:</p>' +
            '<ul class="gbs-hs-card__list gbs-hs-card__list--muted">' +
              '<li>EA–AU Falcon builds</li><li>Experienced installers</li><li>Existing custom wiring</li>' +
            '</ul>' +
          '</div>' +
        '</button>' +

      '</div>' +

      '<div class="gbs-hs__info">' +
        '<p class="gbs-hs__info-title">Which option should I choose?</p>' +
        '<p class="gbs-hs__info-text">' + hintText + '</p>' +
      '</div>' +

      (patrolVeh
        ? '<div class="gbs-patrol-harness-note">' +
            '<p class="gbs-patrol-harness-note__heading">&#11088; Recommended for This Conversion</p>' +
            '<p class="gbs-patrol-harness-note__body">The <strong>Standalone Harness with Fuse Box</strong> is the correct and recommended harness for a Nissan Patrol Barra conversion. The Patrol\'s factory electrical system does not have a relay and fuse layout compatible with the integration harness — the standalone harness provides everything needed in one self-contained unit.</p>' +
            '<p class="gbs-patrol-harness-note__body">Includes: ignition power, starter trigger, fuel pump control, and thermo fan control — all independently managed by the harness fuse box.</p>' +
          '</div>'
        : '')
    );
  }

  /* ── Step 5 (6-cyl N/A): ECU Programming Service ─────────────── */
  function buildEcuBody() {
    if (isTurboEngine()) return buildTurboEcuBody();
    var sel = function (v) { return state.ecu === v ? ' is-selected' : ''; };
    return (
      '<h3 class="gbs-tecu__heading">ECU Programming Service</h3>' +
      '<p class="gbs-tecu__sub">Select the ECU service that applies to your build. This determines what we need to supply or program for your conversion.</p>' +
      '<div class="gbs-tecu__cards">' +

        '<button class="gbs-tecu-card' + sel('have-no-service') + '" data-key="ecu" data-value="have-no-service" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">No Programming Needed</span>' +
            '<span class="gbs-tecu-card__title">I Already Have a Programmed ECU</span>' +
            '<span class="gbs-tecu-card__tagline">No ECU Service Required</span>' +
            '<span class="gbs-tecu-card__desc">Your ECU is already unlocked, PATS removed and configured for standalone operation.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('have-mail-in') + '" data-key="ecu" data-value="have-mail-in" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Mail-In Programming</span>' +
            '<span class="gbs-tecu-card__title">I Have an ECU — Send for Programming</span>' +
            '<span class="gbs-tecu-card__tagline">PATS Removal &amp; Standalone Configuration</span>' +
            '<span class="gbs-tecu-card__desc">Send us your Barra ECU and we\'ll unlock it, remove PATS, and configure it for standalone operation.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('need') + '" data-key="ecu" data-value="need" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">GBS Supplies ECU</span>' +
            '<span class="gbs-tecu-card__title">I Need GBS to Supply an ECU</span>' +
            '<span class="gbs-tecu-card__tagline">GBS Will Source &amp; Program Your ECU</span>' +
            '<span class="gbs-tecu-card__desc">We\'ll source and program a standalone Barra ECU ready for your conversion.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

      '</div>'
    );
  }

  /* ── Step 5 (6-cyl Turbo): Turbo ECU & Boost Control ─────────── */
  function buildTurboEcuBody() {
    var sel = function (v) { return state.ecu === v ? ' is-selected' : ''; };
    return (
      '<h3 class="gbs-tecu__heading">What ECU are you using?</h3>' +
      '<p class="gbs-tecu__sub">Select the option below so we can recommend the correct wiring harness and features for your setup.</p>' +
      '<div class="gbs-tecu__cards">' +

        '<button class="gbs-tecu-card' + sel('factory-turbo') + '" data-key="ecu" data-value="factory-turbo" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Factory Turbo Compatible</span>' +
            '<span class="gbs-tecu-card__title">I Already Have a Factory Turbo ECU</span>' +
            '<span class="gbs-tecu-card__tagline">Retains Factory ECU-Controlled Boost</span>' +
            '<span class="gbs-tecu-card__desc">Best option if you\'re using a genuine factory turbo Barra ECU.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('na-ecu') + '" data-key="ecu" data-value="na-ecu" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">External Boost Control</span>' +
            '<span class="gbs-tecu-card__title">I Already Have an N/A ECU</span>' +
            '<span class="gbs-tecu-card__tagline">External Boost Control</span>' +
            '<span class="gbs-tecu-card__desc">Suitable for N/A ECUs or turbo conversions using external boost control.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('need-supply') + '" data-key="ecu" data-value="need-supply" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">GBS Supplies ECU</span>' +
            '<span class="gbs-tecu-card__title">I Need GBS to Supply an ECU</span>' +
            '<span class="gbs-tecu-card__tagline">GBS Will Supply &amp; Program Your ECU</span>' +
            '<span class="gbs-tecu-card__desc">We\'ll source, configure and program the correct ECU for your conversion.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('not-sure') + '" data-key="ecu" data-value="not-sure" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Help Me Choose</span>' +
            '<span class="gbs-tecu-card__title">I\'m Not Sure</span>' +
            '<span class="gbs-tecu-card__tagline">We\'ll Help You Choose</span>' +
            '<span class="gbs-tecu-card__desc">If you\'re unsure which ECU you have, we\'ll guide you through the correct option.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

      '</div>' +

      '<div class="gbs-hs__info">' +
        '<p class="gbs-hs__info-title">Which option applies to me?</p>' +
        '<p class="gbs-hs__info-text">A <strong>Turbo Ready Harness</strong> is only required when using a genuine factory turbo ECU with factory ECU-controlled boost. If you are running external boost control or are unsure, the <strong>Standard Harness</strong> is the correct choice.</p>' +
      '</div>'
    );
  }

  /* ── ECU Service (V8 & Boss V8) ───────────────────────────────── */
  function buildEcuServiceBody() {
    var sel = function (v) { return state.ecu === v ? ' is-selected' : ''; };
    return (
      '<h3 class="gbs-tecu__heading">ECU Service</h3>' +
      '<p class="gbs-tecu__sub">Let us know your ECU situation so we can include the right details in your build consultation.</p>' +
      '<div class="gbs-tecu__cards">' +

        '<button class="gbs-tecu-card' + sel('have-no-service') + '" data-key="ecu" data-value="have-no-service" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">ECU Supplied</span>' +
            '<span class="gbs-tecu-card__title">I Already Have an ECU</span>' +
            '<span class="gbs-tecu-card__tagline">Existing ECU Setup</span>' +
            '<span class="gbs-tecu-card__desc">I have an ECU for this build that I\'ll be using.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('need') + '" data-key="ecu" data-value="need" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">ECU Required</span>' +
            '<span class="gbs-tecu-card__title">I Need an ECU</span>' +
            '<span class="gbs-tecu-card__tagline">ECU Supply Needed</span>' +
            '<span class="gbs-tecu-card__desc">I need help sourcing and configuring an ECU for this build.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('not-sure') + '" data-key="ecu" data-value="not-sure" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Need Advice</span>' +
            '<span class="gbs-tecu-card__title">I\'m Not Sure</span>' +
            '<span class="gbs-tecu-card__tagline">Discuss Options With Our Team</span>' +
            '<span class="gbs-tecu-card__desc">ECU options will be discussed as part of your build consultation.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

      '</div>'
    );
  }

  /* ── Animation helpers for inline reveals ───────────────────── */
  function slideDown(el) {
    el.hidden = false;
    el.style.maxHeight = '0';
    el.style.opacity   = '0';
    el.style.overflow  = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.transition = 'max-height 0.28s cubic-bezier(0.4,0,0.2,1), opacity 0.22s ease';
        el.style.maxHeight  = (el.scrollHeight + 200) + 'px';
        el.style.opacity    = '1';
        function onEnd(e) {
          if (e.propertyName !== 'max-height') return;
          el.style.maxHeight  = 'none';
          el.style.overflow   = '';
          el.style.transition = '';
          el.removeEventListener('transitionend', onEnd);
        }
        el.addEventListener('transitionend', onEnd);
      });
    });
  }

  function slideUp(el) {
    el.style.maxHeight  = el.scrollHeight + 'px';
    el.style.overflow   = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.transition = 'max-height 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.2s ease';
        el.style.maxHeight  = '0';
        el.style.opacity    = '0';
        function onEnd(e) {
          if (e.propertyName !== 'max-height') return;
          el.hidden           = true;
          el.style.maxHeight  = '';
          el.style.opacity    = '';
          el.style.overflow   = '';
          el.style.transition = '';
          el.removeEventListener('transitionend', onEnd);
        }
        el.addEventListener('transitionend', onEnd);
      });
    });
  }

  /* ── Shared: add-ons price summary ──────────────────────────── */
  function addonsSummaryInner() {
    var hasObd  = state.features.indexOf('obd') !== -1;
    var hasDash = state.dashProvision === true;
    var total   = (hasObd ? 25 : 0) + (hasDash ? 25 : 0);
    if (total === 0) {
      return '<span class="gbs-builder-addons__empty">No optional add-ons selected</span>';
    }
    var h = '<p class="gbs-builder-addons__heading">Add-ons selected</p><ul class="gbs-builder-addons__list">';
    if (hasObd)  h += '<li><span>2m Extended OBDII Lead</span><span class="gbs-builder-addons__price">+$25</span></li>';
    if (hasDash) h += '<li><span>Aftermarket Dash Provision</span><span class="gbs-builder-addons__price">+$25</span></li>';
    h += '</ul><div class="gbs-builder-addons__total"><span>Total add-ons</span><span class="gbs-builder-addons__price gbs-builder-addons__price--total">+$' + total + '</span></div>';
    return h;
  }

  function updateAddonsSummary(card) {
    var el = card.querySelector('#gbsAddonsTotal');
    if (el) el.innerHTML = addonsSummaryInner();
  }

  /* ── Shared: Aftermarket Dash Provision section HTML ─────────── */
  function buildDashSectionHTML() {
    var isDash = state.dashProvision === true;
    var h = '<div class="gbs-obd-section" id="gbsDashSection">';
    h +=   '<h3 class="gbs-obd__heading">Aftermarket Dash Provision</h3>';
    h +=   '<p class="gbs-obd__sub">Planning to run an aftermarket digital dash? We can add a dedicated provision plug to your loom so your dash is plug-and-play at installation.</p>';

    h += '<div class="gbs-feat-toggle-card' + (isDash ? ' is-on' : '') + '">';
    h +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (isDash ? 'true' : 'false') + '" data-dash-toggle type="button">';
    h +=     '<span class="gbs-feat-toggle-card__label">Add Aftermarket Dash Provision <span class="gbs-feat-toggle-card__tag">+$25</span></span>';
    h +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
    h +=   '</button>';
    h +=   '<div class="gbs-feat-toggle-card__reveal"' + (isDash ? '' : ' hidden') + '>';
    h +=     '<p class="gbs-feat-toggle-card__reveal-text">We\'ll add a provision plug to your loom so your dash is plug-and-play at installation. No field wiring required.</p>';
    h +=     '<ul class="gbs-obd-card__benefits">';
    h +=       '<li>Compatible with Haltech, Powertune Digital, AIM, Racepak and more</li>';
    h +=       '<li>Clean plug-and-play connection</li>';
    h +=       '<li>No cutting or splicing at install</li>';
    h +=     '</ul>';
    h +=     '<div class="gbs-dash-input-inline">';
    h +=       '<label class="gbs-cluster-field__label" for="gbsDashModelInput">Dash brand and model <span class="gbs-req">*</span></label>';
    h +=       '<input class="gbs-cluster-field__input" id="gbsDashModelInput" type="text" autocomplete="off" placeholder="e.g. Haltech iC-7, Powertune Digital, AIM MXS, Racepak Vantage…" value="' + esc(state.dashModel || '') + '" />';
    h +=       '<p class="gbs-obd__sub" style="margin-top:0.8rem;margin-bottom:0;">We\'ll add the correct provision plug to your loom to suit your specific dash.</p>';
    h +=     '</div>';
    h +=   '</div>';
    h += '</div>';

    h += '</div>';
    h += '<div class="gbs-builder-addons" id="gbsAddonsTotal">' + addonsSummaryInner() + '</div>';
    return h;
  }

  /* ── Features (6-cyl) ────────────────────────────────────────── */
  function buildFeaturesBody() {
    var isZf       = state.transmission === 'zf';
    var hasAc      = state.features.indexOf('ac')      !== -1;
    var hasCruise  = state.features.indexOf('cruise')  !== -1;
    var hasCluster = state.features.indexOf('cluster') !== -1;
    var hasObd     = state.features.indexOf('obd')     !== -1;
    var needsCb    = hasAc || hasCluster || isZf;

    var html = '<div class="gbs-feat-toggles">';

    if (!isZf) {
      /* — AC toggle (not shown for ZF — AC wiring is included as standard) */
      html += '<div class="gbs-feat-toggle-card' + (hasAc ? ' is-on' : '') + '">';
      html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasAc ? 'true' : 'false') + '" data-feat="ac" type="button">';
      html +=     '<span class="gbs-feat-toggle-card__label">Retain Air Conditioning</span>';
      html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
      html +=   '</button>';
      html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasAc ? '' : ' hidden') + '>';
      html +=     '<p class="gbs-feat-toggle-card__reveal-text">Air conditioning retention requires a <strong>CANBarra module</strong>, which enables the Barra ECU to communicate with your vehicle\'s factory body control systems via CAN bus. Please provide your vehicle details in the section below.</p>';
      html +=   '</div>';
      html += '</div>';

      /* — Cruise toggle (not shown for ZF — cruise wiring is included as standard) */
      html += '<div class="gbs-feat-toggle-card' + (hasCruise ? ' is-on' : '') + '">';
      html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasCruise ? 'true' : 'false') + '" data-feat="cruise" type="button">';
      html +=     '<span class="gbs-feat-toggle-card__label">Retain Cruise Control</span>';
      html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
      html +=   '</button>';
      html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasCruise ? '' : ' hidden') + '>';
      html +=     '<p class="gbs-feat-toggle-card__reveal-text">Cruise control requires a vehicle speed input to the ECU. We will review your order and contact you if any additional components are required.</p>';
      html +=   '</div>';
      html += '</div>';

      /* — Cluster toggle (not shown for ZF — factory dash integration is via CANBarra) */
      html += '<div class="gbs-feat-toggle-card' + (hasCluster ? ' is-on' : '') + '">';
      html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasCluster ? 'true' : 'false') + '" data-feat="cluster" type="button">';
      html +=     '<span class="gbs-feat-toggle-card__label">Retain Factory Cluster</span>';
      html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
      html +=   '</button>';
      html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasCluster ? '' : ' hidden') + '>';
      html +=     '<p class="gbs-feat-toggle-card__reveal-text" style="margin-bottom:1.2rem">Retaining your factory instrument cluster <strong>cannot be guaranteed</strong> for every vehicle. Please provide your cluster type below so we can review your setup.</p>';
      html +=     '<div class="gbs-cluster-fields">';
      html +=       '<label class="gbs-cluster-field gbs-cluster-field--full">';
      html +=         '<span class="gbs-cluster-field__label">Factory Cluster Type <span class="gbs-req">*</span></span>';
      html +=         '<input class="gbs-cluster-field__input" id="gbsClusterType" type="text" placeholder="e.g. Analogue, LCD, digital dash" autocomplete="off" value="' + esc(state.clusterInfo.clusterType) + '" />';
      html +=       '</label>';
      html +=       '<label class="gbs-cluster-field gbs-cluster-field--full">';
      html +=         '<span class="gbs-cluster-field__label">Additional Notes <span class="gbs-cluster-field__opt">(optional)</span></span>';
      html +=         '<textarea class="gbs-cluster-field__input gbs-cluster-field__textarea" id="gbsClusterNotes" rows="3" placeholder="Any other details about your dash, cluster, or wiring setup…">' + esc(state.clusterInfo.notes) + '</textarea>';
      html +=       '</label>';
      html +=     '</div>';
      html +=     '<p class="gbs-feat-toggle-card__reveal-footer">This information will be sent with your order and we\'ll review it before building your harness.</p>';
      html +=   '</div>';
      html += '</div>';
    } else {
      /* ZF Automatic — show an informational note instead of toggles */
      html += '<div class="gbs-feat-toggle-card gbs-feat-toggle-card--info">';
      html +=   '<p class="gbs-feat-toggle-card__header gbs-feat-toggle-card__header--static">';
      html +=     '<span class="gbs-feat-toggle-card__label">&#10003;&nbsp; Air conditioning, cruise control, and factory dash integration are all included as standard in your ZF Automatic harness.</span>';
      html +=   '</p>';
      html += '</div>';
    }

    html += '</div>';

    /* — CANBarra vehicle details (shown when AC or Cluster is on) */
    html += '<div class="gbs-canbarra-block" id="gbsCanbarraBlock"' + (needsCb ? '' : ' hidden') + '>';
    html +=   '<p class="gbs-canbarra-block__heading">&#8505; CANBarra Configuration — Vehicle Details Required</p>';
    html +=   '<p class="gbs-canbarra-block__body">A <strong>CANBarra module</strong> is required with your selected features. Please provide your vehicle details so we can configure it correctly.</p>';
    html +=   '<div class="gbs-cluster-fields">';
    html +=     '<label class="gbs-cluster-field gbs-cluster-field--full">';
    html +=       '<span class="gbs-cluster-field__label">Vehicle Make and Model <span class="gbs-req">*</span></span>';
    html +=       '<input class="gbs-cluster-field__input" id="gbsCanbarraMakeModel" type="text" placeholder="e.g. XD Falcon, VP Commodore, Nissan GQ Patrol" autocomplete="off" value="' + esc(state.canbarraInfo.vehicleMakeModel || '') + '" />';
    html +=     '</label>';
    html +=     '<label class="gbs-cluster-field">';
    html +=       '<span class="gbs-cluster-field__label">Vehicle Year <span class="gbs-req">*</span></span>';
    html +=       '<input class="gbs-cluster-field__input" id="gbsCanbarraYear" type="text" placeholder="e.g. 1995" autocomplete="off" value="' + esc(state.canbarraInfo.year) + '" />';
    html +=     '</label>';
    html +=     '<label class="gbs-cluster-field">';
    html +=       '<span class="gbs-cluster-field__label">Original Engine <span class="gbs-req">*</span></span>';
    html +=       '<input class="gbs-cluster-field__input" id="gbsCanbarraEngine" type="text" placeholder="e.g. 4.0L EFI, 5.0L V8" autocomplete="off" value="' + esc(state.canbarraInfo.originalEngine) + '" />';
    html +=     '</label>';
    html +=   '</div>';
    html +=   '<p class="gbs-canbarra-block__footer">These details help us configure the CANBarra module correctly for your specific vehicle.</p>';
    html += '</div>';

    /* — OBDII section */
    var stdSel  = !hasObd ? ' is-selected' : '';
    var extSel  = hasObd  ? ' is-selected' : '';
    var stdOpen = !hasObd ? ' gbs-reveal-open' : '';
    var extOpen = hasObd  ? ' gbs-reveal-open' : '';
    html += '<div class="gbs-obd-section">';
    html +=   '<h3 class="gbs-obd__heading">OBDII Diagnostic Port</h3>';
    html +=   '<p class="gbs-obd__sub">Choose where you\'d like your diagnostic (OBDII) port located.</p>';
    html +=   '<div class="gbs-obd__cards">';

    html +=   '<div class="gbs-obd-item' + stdOpen + '">';
    html +=     '<button class="gbs-obd-card' + stdSel + '" data-obd-value="standard" type="button">';
    html +=       '<span class="gbs-obd-card__radio"><span class="gbs-obd-card__radio-inner"></span></span>';
    html +=       '<span class="gbs-obd-card__body"><span class="gbs-obd-card__title">Standard Location</span><span class="gbs-obd-card__price-tag">Included</span></span>';
    html +=       '<span class="gbs-obd-card__check" aria-hidden="true">&#10003;</span>';
    html +=     '</button>';
    html +=     '<div class="gbs-obd-card__desc-reveal"' + (!hasObd ? '' : ' hidden') + '>';
    html +=       '<p class="gbs-obd-card__desc-reveal-text">Mounted near the ECU as standard. Suitable for most builds where engine bay access isn\'t an issue.</p>';
    html +=     '</div>';
    html +=   '</div>';

    html +=   '<div class="gbs-obd-item' + extOpen + '">';
    html +=     '<button class="gbs-obd-card' + extSel + '" data-obd-value="extended" type="button">';
    html +=       '<span class="gbs-obd-card__radio"><span class="gbs-obd-card__radio-inner"></span></span>';
    html +=       '<span class="gbs-obd-card__body"><span class="gbs-obd-card__badge">&#11088; Recommended</span><span class="gbs-obd-card__title">Extended into the Cabin</span><span class="gbs-obd-card__price-tag gbs-obd-card__price-tag--upgrade">+$25</span></span>';
    html +=       '<span class="gbs-obd-card__check" aria-hidden="true">&#10003;</span>';
    html +=     '</button>';
    html +=     '<div class="gbs-obd-card__desc-reveal"' + (hasObd ? '' : ' hidden') + '>';
    html +=       '<p class="gbs-obd-card__desc-reveal-text">Keeps the diagnostic port inside the cabin for quick and easy access.</p>';
    html +=       '<ul class="gbs-obd-card__benefits"><li>Easy to plug in scan tools</li><li>Easier ECU tuning access</li><li>No need to open the engine bay every time</li></ul>';
    html +=     '</div>';
    html +=   '</div>';

    html +=   '</div>';
    html += '</div>';

    html += buildDashSectionHTML();
    html += '<button class="gbs-step__next-btn" id="gbsFeatDone" type="button">See My Recommended Setup &#8594;</button>';
    return html;
  }

  /* ── Features (V8 & Boss V8) ─────────────────────────────────── */
  function buildFeaturesV8Body() {
    var hasAc      = state.features.indexOf('ac')      !== -1;
    var hasCruise  = state.features.indexOf('cruise')  !== -1;
    var hasCluster = state.features.indexOf('cluster') !== -1;
    var hasObd     = state.features.indexOf('obd')     !== -1;

    var html = '<div class="gbs-feat-toggles">';

    /* — AC toggle */
    html += '<div class="gbs-feat-toggle-card' + (hasAc ? ' is-on' : '') + '">';
    html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasAc ? 'true' : 'false') + '" data-feat="ac" type="button">';
    html +=     '<span class="gbs-feat-toggle-card__label">Retain Air Conditioning</span>';
    html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
    html +=   '</button>';
    html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasAc ? '' : ' hidden') + '>';
    html +=     '<p class="gbs-feat-toggle-card__reveal-text">Air conditioning retention will be discussed and confirmed as part of your V8 build consultation.</p>';
    html +=   '</div>';
    html += '</div>';

    /* — Cruise toggle */
    html += '<div class="gbs-feat-toggle-card' + (hasCruise ? ' is-on' : '') + '">';
    html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasCruise ? 'true' : 'false') + '" data-feat="cruise" type="button">';
    html +=     '<span class="gbs-feat-toggle-card__label">Retain Cruise Control</span>';
    html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
    html +=   '</button>';
    html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasCruise ? '' : ' hidden') + '>';
    html +=     '<p class="gbs-feat-toggle-card__reveal-text">Cruise control requires a vehicle speed input to the ECU. The required setup will be discussed as part of your V8 build consultation.</p>';
    html +=   '</div>';
    html += '</div>';

    /* — Cluster toggle */
    html += '<div class="gbs-feat-toggle-card' + (hasCluster ? ' is-on' : '') + '">';
    html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasCluster ? 'true' : 'false') + '" data-feat="cluster" type="button">';
    html +=     '<span class="gbs-feat-toggle-card__label">Retain Factory Cluster</span>';
    html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
    html +=   '</button>';
    html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasCluster ? '' : ' hidden') + '>';
    html +=     '<p class="gbs-feat-toggle-card__reveal-text">Factory cluster retention will be discussed as part of your V8 build consultation. Please include any cluster details in the contact message.</p>';
    html +=   '</div>';
    html += '</div>';

    /* — OBD toggle (V8 uses a toggle, not a full radio section) */
    html += '<div class="gbs-feat-toggle-card' + (hasObd ? ' is-on' : '') + '">';
    html +=   '<button class="gbs-feat-toggle-card__header" role="switch" aria-checked="' + (hasObd ? 'true' : 'false') + '" data-feat="obd" type="button">';
    html +=     '<span class="gbs-feat-toggle-card__label">Extended OBDII Port <span class="gbs-feat-toggle-card__tag">+$25</span></span>';
    html +=     '<span class="gbs-feat-toggle-card__mark" aria-hidden="true"><span class="gbs-feat-toggle-card__mark-tick">&#10003;</span></span>';
    html +=   '</button>';
    html +=   '<div class="gbs-feat-toggle-card__reveal"' + (hasObd ? '' : ' hidden') + '>';
    html +=     '<p class="gbs-feat-toggle-card__reveal-text">Extends the OBDII diagnostic port 2 metres into the cabin for fast, convenient access during tuning and diagnostics. No need to open the engine bay for scan tool or tuner connections.</p>';
    html +=   '</div>';
    html += '</div>';

    html += '</div>';

    html += buildDashSectionHTML();
    html += '<button class="gbs-step__next-btn" id="gbsFeatDone" type="button">See My Configuration Summary &#8594;</button>';
    return html;
  }

  /* ── SOHC: Engine / Vehicle Selection (Step 1) ──────────────── */
  function buildSohcEngineBody() {
    var sel = function (v) { return state.sohcEngine === v ? ' is-selected' : ''; };
    var h = '';
    h += '<div class="gbs-sohc-intro">';
    h +=   '<p class="gbs-sohc-intro__text">Run your existing Ford SOHC engine using a modern factory Barra ECU and a purpose-built conversion loom. This setup provides modern tuning support, OBDII diagnostics and improved engine-management flexibility without requiring a complete Barra engine conversion.</p>';
    h +=   '<p class="gbs-sohc-intro__note"><strong>Note:</strong> This pathway is for SOHC engines only. It is not intended for Barra, Barra V8 or Boss engine conversions.</p>';
    h += '</div>';
    h += '<p class="gbs-step__group-label">Ford Falcon SOHC</p>';
    h += '<div class="gbs-step__options">';
    var falcons = ['eb-falcon','ed-falcon','ef-falcon','el-falcon','au-falcon'];
    falcons.forEach(function (k) {
      var c = SOHC_COMPAT[k];
      h += '<button class="gbs-opt' + sel(k) + '" data-key="sohcEngine" data-value="' + k + '" type="button">' + esc(c.label) + '<span class="gbs-opt__sub"> ' + esc(c.years) + '</span></button>';
    });
    h += '</div>';
    h += '<p class="gbs-step__group-label">Other</p>';
    h += '<div class="gbs-step__options">';
    h += '<button class="gbs-opt' + sel('other-sohc') + '" data-key="sohcEngine" data-value="other-sohc" type="button">Other SOHC Setup</button>';
    h += '<button class="gbs-opt' + sel('unsure-sohc') + '" data-key="sohcEngine" data-value="unsure-sohc" type="button">Not Sure</button>';
    h += '</div>';
    return h;
  }

  /* ── SOHC: Loom Setup (Step 4) ──────────────────────────────── */
  function buildSohcLoomBody() {
    var compat  = state.sohcEngine ? SOHC_COMPAT[state.sohcEngine] : null;
    var avail   = compat ? compat.looms : ['standalone', 'integration'];
    var selSt   = state.harnessStyle === 'standalone'  ? ' is-selected' : '';
    var selIn   = state.harnessStyle === 'integration' ? ' is-selected' : '';
    var h = '';
    h += '<p class="gbs-hs__sub">Select the loom setup for your SOHC Barra ECU conversion.</p>';
    h += '<div class="gbs-hs__cards">';
    if (avail.indexOf('standalone') !== -1) {
      h += '<button class="gbs-hs-card' + selSt + '" data-key="harnessStyle" data-value="standalone" type="button">';
      h +=   '<div class="gbs-hs-card__top"><span class="gbs-hs-card__no-badge"></span><span class="gbs-hs-card__circle"><span class="gbs-hs-card__tick">&#10003;</span></span></div>';
      h +=   '<h3 class="gbs-hs-card__title">Relay Box Standalone Setup</h3>';
      h +=   '<p class="gbs-hs-card__desc">A complete standalone power-control system that operates ignition power, starter trigger, fuel pump and thermo fans through its own relay and fuse box.</p>';
      h +=   '<div class="gbs-hs-card__suited"><p class="gbs-hs-card__section-label">Best suited for:</p><ul class="gbs-hs-card__list gbs-hs-card__list--muted"><li>Custom or stripped builds</li><li>Non-standard wiring setups</li></ul></div>';
      h += '</button>';
    }
    if (avail.indexOf('integration') !== -1) {
      h += '<button class="gbs-hs-card' + selIn + '" data-key="harnessStyle" data-value="integration" type="button">';
      h +=   '<div class="gbs-hs-card__top"><span class="gbs-hs-card__badge">&#11088; Recommended for Falcons</span><span class="gbs-hs-card__circle"><span class="gbs-hs-card__tick">&#10003;</span></span></div>';
      h +=   '<h3 class="gbs-hs-card__title">Vehicle-Integrated Non-Relay Setup</h3>';
      h +=   '<p class="gbs-hs-card__desc">Integrates into the vehicle\'s existing relay and fuse system. Purpose-built for Falcon-to-Falcon SOHC conversions where the factory wiring is retained.</p>';
      h +=   '<div class="gbs-hs-card__suited"><p class="gbs-hs-card__section-label">Best suited for:</p><ul class="gbs-hs-card__list gbs-hs-card__list--muted"><li>EB / ED / EF / EL / AU Falcon</li><li>Factory wiring retained</li></ul></div>';
      h += '</button>';
    }
    h += '</div>';
    h += '<div class="gbs-hs__info"><p class="gbs-hs__info-title">Which option should I choose?</p><p class="gbs-hs__info-text">For Falcon-based SOHC conversions we recommend the <strong>Vehicle-Integrated Non-Relay Setup</strong>. Falcon vehicles from EA and XH onwards have a compatible relay and fuse layout that this harness is designed to work with.</p></div>';
    return h;
  }

  /* ── SOHC: Transmission (Step 5) ────────────────────────────── */
  function buildSohcTransmissionBody() {
    var compat    = state.sohcEngine ? SOHC_COMPAT[state.sohcEngine] : null;
    var available = compat ? compat.transmissions : ['manual','btr','other'];
    var h = '<p class="gbs-step__group-label">Select your transmission</p><div class="gbs-step__options">';
    available.forEach(function (v) {
      var sel = state.sohcTransmission === v ? ' is-selected' : '';
      h += '<button class="gbs-opt' + sel + '" data-key="sohcTransmission" data-value="' + v + '" type="button">' + esc(SOHC_TRANS_LABELS[v] || v) + '</button>';
    });
    h += '</div>';
    return h;
  }

  /* ── SOHC: ECU Programming Info (Step 2) ────────────────────── */
  function buildSohcEcuInfoBody() {
    var h = '';
    h += '<div class="gbs-sohc-ecu-info">';

    h += '<div class="gbs-sohc-ecu-card">';
    h +=   '<span class="gbs-sohc-ecu-card__badge">&#11088; Recommended</span>';
    h +=   '<h3 class="gbs-sohc-ecu-card__heading">&#128295; ECU Programming Recommendation</h3>';
    h +=   '<p class="gbs-sohc-ecu-card__text">At this stage, Greens Barra Solutions does not offer ECU programming for BA SOHC conversions.</p>';
    h +=   '<p class="gbs-sohc-ecu-card__text">As every engine combination is different, we strongly recommend having your BA Barra ECU professionally custom tuned to suit your specific SOHC engine and vehicle once the conversion is complete.</p>';
    h +=   '<p class="gbs-sohc-ecu-card__text">A custom tune allows your tuner to optimise:</p>';
    h +=   '<ul class="gbs-sohc-ecu-card__list">';
    h +=     '<li>Fuel delivery</li>';
    h +=     '<li>Ignition timing</li>';
    h +=     '<li>Idle quality</li>';
    h +=     '<li>Cold starting</li>';
    h +=     '<li>Drivability</li>';
    h +=     '<li>Overall engine safety</li>';
    h +=   '</ul>';
    h +=   '<p class="gbs-sohc-ecu-card__note">This provides the safest and most reliable outcome for your individual setup.</p>';
    h += '</div>';

    h += '<div class="gbs-sohc-ecu-card gbs-sohc-ecu-card--secondary">';
    h +=   '<h3 class="gbs-sohc-ecu-card__heading">&#9654;&#65039; BA SOHC Safe Startup Calibration</h3>';
    h +=   '<p class="gbs-sohc-ecu-card__text">We are currently developing a safe startup calibration specifically for BA SOHC conversions, that will allow customers to safely start, run and move their vehicle prior to final tuning.</p>';
    h +=   '<p class="gbs-sohc-ecu-card__text">This calibration is still undergoing research and development to ensure it meets our quality, reliability and safety standards before release.</p>';
    h +=   '<p class="gbs-sohc-ecu-card__text"><strong>It is not yet available for purchase.</strong></p>';
    h += '</div>';

    h += '<p class="gbs-sohc-ecu-footer">Our SOHC conversion harnesses are designed to work with a compatible Barra ECU. Until our startup calibration becomes available, ECU programming will need to be arranged through a professional tuner.</p>';
    h += '<button class="gbs-step__next-btn" id="gbsSohcEcuInfoContinue" type="button">Continue to ECU Generation &#8594;</button>';
    h += '</div>';
    return h;
  }

  /* ── SOHC: ECU Service — FUTURE (kept for re-enablement) ─────── */
  function buildSohcEcuServiceBody() {
    var sel = function (v) { return state.ecu === v ? ' is-selected' : ''; };
    return (
      '<h3 class="gbs-tecu__heading">Do You Require an ECU?</h3>' +
      '<p class="gbs-tecu__sub">Select the ECU service that applies to your build. Your Barra ECU will control the SOHC engine.</p>' +
      '<div class="gbs-tecu__cards">' +

        '<button class="gbs-tecu-card' + sel('need') + '" data-key="ecu" data-value="need" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">GBS Supplies ECU</span>' +
            '<span class="gbs-tecu-card__title">Supply Me With a Programmed Barra ECU</span>' +
            '<span class="gbs-tecu-card__tagline">GBS Will Source &amp; Program Your ECU</span>' +
            '<span class="gbs-tecu-card__desc">We\'ll source and program a standalone Barra ECU ready for your SOHC conversion.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('have-mail-in') + '" data-key="ecu" data-value="have-mail-in" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Mail-In Programming</span>' +
            '<span class="gbs-tecu-card__title">I Already Have a Barra ECU and Require the Mail-In ECU Service</span>' +
            '<span class="gbs-tecu-card__tagline">PATS Removal &amp; Standalone Configuration</span>' +
            '<span class="gbs-tecu-card__desc">Send us your Barra ECU and we\'ll unlock it, remove PATS, and configure it for standalone operation with your SOHC engine.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('have-no-service') + '" data-key="ecu" data-value="have-no-service" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">No Programming Needed</span>' +
            '<span class="gbs-tecu-card__title">I Already Have a Programmed Barra ECU</span>' +
            '<span class="gbs-tecu-card__tagline">No ECU Service Required</span>' +
            '<span class="gbs-tecu-card__desc">Your Barra ECU is already programmed and ready for standalone operation with your SOHC engine.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

        '<button class="gbs-tecu-card' + sel('ecu-unsure') + '" data-key="ecu" data-value="ecu-unsure" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">Help Me Choose</span>' +
            '<span class="gbs-tecu-card__title">I Am Unsure Which ECU I Need</span>' +
            '<span class="gbs-tecu-card__tagline">Compatibility Confirmation Required</span>' +
            '<span class="gbs-tecu-card__desc">Provide the ECU part number, catch code or clear photos of the ECU label so compatibility can be confirmed before ordering.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

      '</div>'
    );
  }

  /* ── SOHC: ECU Generation (Step 3) — BA only ────────────────── */
  function buildSohcEcuGenBody() {
    var isSel = state.sohcEcuGen === 'ba';
    return (
      '<h3 class="gbs-tecu__heading">ECU Compatibility</h3>' +
      '<p class="gbs-tecu__sub">The SOHC Barra ECU conversion currently supports the BA Barra ECU only. Confirm your ECU below to continue.</p>' +
      '<div class="gbs-tecu__cards">' +

        '<button class="gbs-tecu-card' + (isSel ? ' is-selected' : '') + '" data-key="sohcEcuGen" data-value="ba" type="button">' +
          '<span class="gbs-tecu-card__radio"><span class="gbs-tecu-card__radio-inner"></span></span>' +
          '<span class="gbs-tecu-card__body">' +
            '<span class="gbs-tecu-card__badge">&#10003; Currently Supported</span>' +
            '<span class="gbs-tecu-card__title">BA Barra ECU</span>' +
            '<span class="gbs-tecu-card__tagline">BA Falcon PCM — 2002 to 2005</span>' +
            '<span class="gbs-tecu-card__desc">Our SOHC conversion harness is designed and built specifically for the BA Falcon Barra PCM. This is the only ECU generation currently supported.</span>' +
          '</span>' +
          '<span class="gbs-tecu-card__check" aria-hidden="true">&#10003;</span>' +
        '</button>' +

      '</div>' +

      '<div class="gbs-hs__info">' +
        '<p class="gbs-hs__info-title">Using a different ECU?</p>' +
        '<p class="gbs-hs__info-text">We currently only offer SOHC conversion harnesses for the BA Barra ECU. If your build requires a different ECU, <a href="/pages/contact" style="color:#6ab030;">contact us</a> to discuss your application.</p>' +
      '</div>'
    );
  }

  /* ── SOHC: Build Details (Step 6) ───────────────────────────── */
  function buildSohcVehicleInfoBody() {
    var info       = state.sohcVehicleInfo || {};
    var isOther    = state.sohcEngine === 'other-sohc';
    var hasObd     = state.features.indexOf('obd') !== -1;
    var engineLabel = state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? SOHC_COMPAT[state.sohcEngine].label : '';
    var h = '';
    h += '<h3 class="gbs-tecu__heading">Your Build Details</h3>';
    h += '<p class="gbs-tecu__sub">Provide the details of your vehicle and build so we can prepare your SOHC Barra ECU conversion correctly.</p>';
    h += '<div class="gbs-cluster-fields">';
    if (isOther) {
      h += '<label class="gbs-cluster-field">';
      h +=   '<span class="gbs-cluster-field__label">Vehicle Make <span class="gbs-req">*</span></span>';
      h +=   '<input class="gbs-cluster-field__input" id="gbsSohcVehicleMake" type="text" placeholder="e.g. Ford, Holden, Nissan" autocomplete="off" value="' + esc(info.vehicleMake || '') + '" />';
      h += '</label>';
      h += '<label class="gbs-cluster-field">';
      h +=   '<span class="gbs-cluster-field__label">Vehicle Model <span class="gbs-req">*</span></span>';
      h +=   '<input class="gbs-cluster-field__input" id="gbsSohcVehicleModel" type="text" placeholder="e.g. EL Falcon, Patrol, HQ Holden" autocomplete="off" value="' + esc(info.vehicleModel || '') + '" />';
      h += '</label>';
    } else if (engineLabel) {
      h += '<div class="gbs-cluster-field gbs-cluster-field--full gbs-cluster-field--prefill"><span class="gbs-cluster-field__label">Vehicle</span><span class="gbs-cluster-field__prefill">' + esc(engineLabel) + '</span></div>';
    }
    h += '<label class="gbs-cluster-field">';
    h +=   '<span class="gbs-cluster-field__label">Vehicle Year <span class="gbs-req">*</span></span>';
    h +=   '<input class="gbs-cluster-field__input" id="gbsSohcYear" type="text" placeholder="e.g. 1996" autocomplete="off" value="' + esc(info.vehicleYear || '') + '" />';
    h += '</label>';
    if (isOther) {
      h += '<label class="gbs-cluster-field">';
      h +=   '<span class="gbs-cluster-field__label">SOHC Engine <span class="gbs-req">*</span></span>';
      h +=   '<input class="gbs-cluster-field__input" id="gbsSohcOrigEngine" type="text" placeholder="e.g. 4.0L SOHC EFI, 3.9L SOHC" autocomplete="off" value="' + esc(info.originalEngine || '') + '" />';
      h += '</label>';
    }
    h += '<label class="gbs-cluster-field gbs-cluster-field--full">';
    h +=   '<span class="gbs-cluster-field__label">ECU Part Number or Catch Code <span class="gbs-cluster-field__opt">(optional, helps confirm compatibility)</span></span>';
    h +=   '<input class="gbs-cluster-field__input" id="gbsSohcEcuDetails" type="text" placeholder="e.g. 6S4A-12A650-HC or catch code from label" autocomplete="off" value="' + esc(info.ecuDetails || '') + '" />';
    h += '</label>';
    h += '</div>';
    h += '<p class="gbs-step__group-label">Additional Requirements</p>';
    h += '<div class="gbs-step__features">';
    h += '<label class="gbs-feat' + (info.clusterRetain ? ' is-checked' : '') + '" data-value="sohc-cluster" id="gbsSohcCluster"><span class="gbs-feat__box"><span class="gbs-feat__tick">&#10003;</span></span><span class="gbs-feat__label">Retain factory instrument cluster</span></label>';
    h += '<label class="gbs-feat' + (info.acRetain ? ' is-checked' : '') + '" data-value="sohc-ac" id="gbsSohcAc"><span class="gbs-feat__box"><span class="gbs-feat__tick">&#10003;</span></span><span class="gbs-feat__label">Retain air conditioning</span></label>';
    h += '<label class="gbs-feat' + (info.cruiseRetain ? ' is-checked' : '') + '" data-value="sohc-cruise" id="gbsSohcCruise"><span class="gbs-feat__box"><span class="gbs-feat__tick">&#10003;</span></span><span class="gbs-feat__label">Retain cruise control</span></label>';
    h += '</div>';
    var stdObdSel = hasObd ? '' : ' is-selected';
    var extObdSel = hasObd ? ' is-selected' : '';
    h += '<div class="gbs-obd-section">';
    h +=   '<h3 class="gbs-obd__heading">OBDII Diagnostic Port</h3>';
    h +=   '<p class="gbs-obd__sub">Your conversion includes a standard OBDII diagnostic port. Choose where you would like it located — this is the port your tuner and scan tools will connect to.</p>';
    h +=   '<div class="gbs-obd__cards">';
    h +=     '<button class="gbs-obd-card' + stdObdSel + '" data-obd-value="standard" id="gbsSohcObdStd" type="button">';
    h +=       '<span class="gbs-obd-card__radio"><span class="gbs-obd-card__radio-inner"></span></span>';
    h +=       '<span class="gbs-obd-card__body"><span class="gbs-obd-card__title">Standard Location</span><span class="gbs-obd-card__price-tag">Included</span><span class="gbs-obd-card__desc">Port is mounted near the ECU in the engine bay. Suitable for most builds.</span></span>';
    h +=       '<span class="gbs-obd-card__check" aria-hidden="true">&#10003;</span>';
    h +=     '</button>';
    h +=     '<button class="gbs-obd-card' + extObdSel + '" data-obd-value="extended" id="gbsSohcObdExt" type="button">';
    h +=       '<span class="gbs-obd-card__radio"><span class="gbs-obd-card__radio-inner"></span></span>';
    h +=       '<span class="gbs-obd-card__body">';
    h +=         '<span class="gbs-obd-card__badge">&#11088; Recommended</span>';
    h +=         '<span class="gbs-obd-card__title">Extended into the Cabin</span>';
    h +=         '<span class="gbs-obd-card__price-tag gbs-obd-card__price-tag--upgrade">+$25</span>';
    h +=         '<span class="gbs-obd-card__desc">Run the OBDII port into the cabin for fast, convenient access during tuning and diagnostics.</span>';
    h +=         '<ul class="gbs-obd-card__benefits"><li>Plug in scan tools without opening the bonnet</li><li>Easier tuner access during sessions</li><li>Faster fault-code checks</li></ul>';
    h +=       '</span>';
    h +=       '<span class="gbs-obd-card__check" aria-hidden="true">&#10003;</span>';
    h +=     '</button>';
    h +=   '</div>';
    h += '</div>';
    h += buildDashSectionHTML();
    h += '<label class="gbs-cluster-field gbs-cluster-field--full" style="margin-top:1.6rem">';
    h +=   '<span class="gbs-cluster-field__label">Customer Notes <span class="gbs-cluster-field__opt">(optional)</span></span>';
    h +=   '<textarea class="gbs-cluster-field__input gbs-cluster-field__textarea" id="gbsSohcNotes" rows="3" placeholder="Any additional details about your build, special requirements, existing wiring, etc.">' + esc(info.notes || '') + '</textarea>';
    h += '</label>';
    h += '<button class="gbs-step__next-btn" id="gbsSohcVehicleDone" type="button">See My Recommended Setup &#8594;</button>';
    return h;
  }

  function optBtn(opt, key) {
    return '<button class="gbs-opt" data-key="' + esc(key) + '" data-value="' + esc(opt.value) + '" type="button">' + esc(opt.label) + '</button>';
  }

  /* ================================================================
     EVENT BINDING
  ================================================================ */
  function bindListeners(card, stepId) {
    card.querySelectorAll('[data-key]').forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () {
        onSelect(card, b.getAttribute('data-key'), b.getAttribute('data-value'), stepId);
      });
    });

    /* Feature toggle switches (6-cyl and V8) */
    card.querySelectorAll('.gbs-feat-toggle-card__header[data-feat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var feat  = btn.getAttribute('data-feat');
        var nowOn = btn.getAttribute('aria-checked') !== 'true';
        btn.setAttribute('aria-checked', nowOn ? 'true' : 'false');
        var toggleCard = btn.closest('.gbs-feat-toggle-card');
        toggleCard.classList.toggle('is-on', nowOn);

        var idx = state.features.indexOf(feat);
        if (nowOn) { if (idx === -1) state.features.push(feat); }
        else        { if (idx !== -1) state.features.splice(idx, 1); }

        var reveal = toggleCard.querySelector('.gbs-feat-toggle-card__reveal');
        if (reveal) { if (nowOn) slideDown(reveal); else slideUp(reveal); }

        /* V8 OBD toggle updates add-ons price summary */
        if (feat === 'obd') updateAddonsSummary(card);

        /* Show / hide shared CANBarra block when AC or Cluster toggled (6-cyl) */
        if (feat === 'ac' || feat === 'cluster') {
          var hasAcNow      = state.features.indexOf('ac')      !== -1;
          var hasClusterNow = state.features.indexOf('cluster') !== -1;
          var needsCb       = hasAcNow || hasClusterNow || state.transmission === 'zf';
          var cbBlock       = card.querySelector('#gbsCanbarraBlock');
          if (cbBlock) {
            if (needsCb && cbBlock.hidden)   slideDown(cbBlock);
            if (!needsCb && !cbBlock.hidden) slideUp(cbBlock);

            /* Patrol prefill: when CANBarra block appears and no value yet entered */
            if (needsCb && isPatrolVehicle()) {
              var mmField = card.querySelector('#gbsCanbarraMakeModel');
              if (mmField && !mmField.value.trim()) {
                var patrolLabel = displayLabel('vehicle', state.vehicle);
                mmField.value = patrolLabel;
                state.canbarraInfo.vehicleMakeModel = patrolLabel;
              }
            }
          }
        }

        /* Prompt 4: Cluster ON/OFF mutually excludes Aftermarket Dash section */
        if (feat === 'cluster') {
          var dashSection = card.querySelector('#gbsDashSection');
          if (dashSection) {
            if (nowOn) {
              /* Cluster turned ON — clear and hide Aftermarket Dash */
              state.dashProvision = false;
              state.dashModel     = '';
              var dashToggleBtn2 = dashSection.querySelector('[data-dash-toggle]');
              if (dashToggleBtn2) {
                dashToggleBtn2.setAttribute('aria-checked', 'false');
                var dashCard2 = dashToggleBtn2.closest('.gbs-feat-toggle-card');
                if (dashCard2) {
                  dashCard2.classList.remove('is-on');
                  var dashReveal = dashCard2.querySelector('.gbs-feat-toggle-card__reveal');
                  if (dashReveal && !dashReveal.hidden) slideUp(dashReveal);
                }
              }
              if (!dashSection.hidden) slideUp(dashSection);
              updateAddonsSummary(card);
            } else {
              /* Cluster turned OFF — reveal Aftermarket Dash section (unselected) */
              if (dashSection.hidden) slideDown(dashSection);
            }
          }
        }
      });
    });

    /* SOHC feature checkboxes (.gbs-feat) — unchanged */
    card.querySelectorAll('.gbs-feat').forEach(function (lbl) {
      lbl.addEventListener('click', function (e) {
        e.preventDefault();
        var val = lbl.getAttribute('data-value');
        var idx = state.features.indexOf(val);
        if (idx === -1) { state.features.push(val);      lbl.classList.add('is-checked');    }
        else            { state.features.splice(idx, 1); lbl.classList.remove('is-checked'); }
      });
    });

    /* Input listeners (work in both old and new reveal layouts) */
    var clusterType  = card.querySelector('#gbsClusterType');
    var clusterNotes = card.querySelector('#gbsClusterNotes');
    if (clusterType)  clusterType.addEventListener('input',  function () { state.clusterInfo.clusterType = clusterType.value;  clusterType.classList.remove('is-error');  });
    if (clusterNotes) clusterNotes.addEventListener('input', function () { state.clusterInfo.notes       = clusterNotes.value; });

    var canbarraMakeModel = card.querySelector('#gbsCanbarraMakeModel');
    var canbarraYear      = card.querySelector('#gbsCanbarraYear');
    var canbarraEngine    = card.querySelector('#gbsCanbarraEngine');
    if (canbarraMakeModel) canbarraMakeModel.addEventListener('input', function () { state.canbarraInfo.vehicleMakeModel = canbarraMakeModel.value; canbarraMakeModel.classList.remove('is-error'); });
    if (canbarraYear)      canbarraYear.addEventListener('input',      function () { state.canbarraInfo.year             = canbarraYear.value;      canbarraYear.classList.remove('is-error');      });
    if (canbarraEngine)    canbarraEngine.addEventListener('input',    function () { state.canbarraInfo.originalEngine   = canbarraEngine.value;    canbarraEngine.classList.remove('is-error');    });

    card.querySelectorAll('[data-obd-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-obd-value');
        var idx = state.features.indexOf('obd');
        if (val === 'extended') { if (idx === -1) state.features.push('obd'); }
        else                    { if (idx !== -1) state.features.splice(idx, 1); }
        card.querySelectorAll('[data-obd-value]').forEach(function (b) {
          b.classList.remove('is-selected');
          var item = b.closest('.gbs-obd-item');
          if (item) {
            item.classList.remove('gbs-reveal-open');
            var rev = item.querySelector('.gbs-obd-card__desc-reveal');
            if (rev && !rev.hidden) slideUp(rev);
          }
        });
        btn.classList.add('is-selected');
        var selItem = btn.closest('.gbs-obd-item');
        if (selItem) {
          selItem.classList.add('gbs-reveal-open');
          var rev = selItem.querySelector('.gbs-obd-card__desc-reveal');
          if (rev && rev.hidden) slideDown(rev);
        }
        updateAddonsSummary(card);
      });
    });

    /* Dash provision toggle */
    var dashToggleBtn = card.querySelector('[data-dash-toggle]');
    if (dashToggleBtn) {
      dashToggleBtn.addEventListener('click', function () {
        var nowOn = dashToggleBtn.getAttribute('aria-checked') !== 'true';
        state.dashProvision = nowOn;
        if (!nowOn) state.dashModel = '';
        dashToggleBtn.setAttribute('aria-checked', nowOn ? 'true' : 'false');
        var dashCard = dashToggleBtn.closest('.gbs-feat-toggle-card');
        dashCard.classList.toggle('is-on', nowOn);
        var reveal = dashCard.querySelector('.gbs-feat-toggle-card__reveal');
        if (reveal) { if (nowOn) slideDown(reveal); else slideUp(reveal); }
        if (nowOn) {
          setTimeout(function () {
            var mi = card.querySelector('#gbsDashModelInput');
            if (mi) mi.focus();
          }, 320);
        }
        updateAddonsSummary(card);
      });
    }

    var dashModelInput = card.querySelector('#gbsDashModelInput');
    if (dashModelInput) {
      dashModelInput.addEventListener('input', function () {
        state.dashModel = dashModelInput.value;
        dashModelInput.classList.remove('is-error');
      });
    }

    var otherConfirm = card.querySelector('#gbsOtherConfirm');
    var otherInput   = card.querySelector('#gbsOtherInput');
    function submitOtherVehicle() {
      var val = otherInput ? otherInput.value.trim() : '';
      if (!val) {
        if (otherInput) { otherInput.focus(); otherInput.classList.add('is-error'); }
        return;
      }
      state.vehicle = val;
      clearAfter(stepId);
      collapseStep(card, stepId, val);
      if (stepId < TOTAL_STEPS) {
        activeStep = stepId + 1;
        renderProgress();
        appendStep(stepId + 1);
        setTimeout(function () {
          var next = document.getElementById('gbsStep' + (stepId + 1));
          if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 200);
      }
    }
    if (otherConfirm) otherConfirm.addEventListener('click', submitOtherVehicle);
    if (otherInput)   otherInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitOtherVehicle(); }
      else otherInput.classList.remove('is-error');
    });

    /* SOHC: ECU info step — Continue button */
    var sohcEcuInfoContinue = card.querySelector('#gbsSohcEcuInfoContinue');
    if (sohcEcuInfoContinue) {
      sohcEcuInfoContinue.addEventListener('click', function () {
        collapseStep(card, stepId, 'ECU Programming');
        if (stepId < TOTAL_STEPS) {
          activeStep = stepId + 1;
          renderProgress();
          appendStep(stepId + 1);
          setTimeout(function () {
            var next = document.getElementById('gbsStep' + (stepId + 1));
            if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 200);
        }
      });
    }

    /* SOHC: Build details form inputs */
    var sMake    = card.querySelector('#gbsSohcVehicleMake');
    var sModel   = card.querySelector('#gbsSohcVehicleModel');
    var sYear    = card.querySelector('#gbsSohcYear');
    var sOrig    = card.querySelector('#gbsSohcOrigEngine');
    var sEcuDet  = card.querySelector('#gbsSohcEcuDetails');
    var sNotes   = card.querySelector('#gbsSohcNotes');
    function ensureSohcInfo() {
      if (!state.sohcVehicleInfo) state.sohcVehicleInfo = { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' };
    }
    if (sMake)   sMake.addEventListener('input',   function () { ensureSohcInfo(); state.sohcVehicleInfo.vehicleMake   = sMake.value;   sMake.classList.remove('is-error'); });
    if (sModel)  sModel.addEventListener('input',  function () { ensureSohcInfo(); state.sohcVehicleInfo.vehicleModel  = sModel.value;  sModel.classList.remove('is-error'); });
    if (sYear)   sYear.addEventListener('input',   function () { ensureSohcInfo(); state.sohcVehicleInfo.vehicleYear   = sYear.value;   sYear.classList.remove('is-error'); });
    if (sOrig)   sOrig.addEventListener('input',   function () { ensureSohcInfo(); state.sohcVehicleInfo.originalEngine = sOrig.value;  sOrig.classList.remove('is-error'); });
    if (sEcuDet) sEcuDet.addEventListener('input', function () { ensureSohcInfo(); state.sohcVehicleInfo.ecuDetails    = sEcuDet.value; });
    if (sNotes)  sNotes.addEventListener('input',  function () { ensureSohcInfo(); state.sohcVehicleInfo.notes         = sNotes.value; });

    /* SOHC: checkbox toggles in build details */
    ['gbsSohcCluster', 'gbsSohcAc', 'gbsSohcCruise'].forEach(function (id) {
      var el = card.querySelector('#' + id);
      if (!el) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        ensureSohcInfo();
        var map = { gbsSohcCluster: 'clusterRetain', gbsSohcAc: 'acRetain', gbsSohcCruise: 'cruiseRetain' };
        var k = map[id];
        state.sohcVehicleInfo[k] = !state.sohcVehicleInfo[k];
        if (state.sohcVehicleInfo[k]) el.classList.add('is-checked');
        else el.classList.remove('is-checked');
      });
    });

    /* SOHC: OBD card buttons in build details */
    var sohcObdStd = card.querySelector('#gbsSohcObdStd');
    var sohcObdExt = card.querySelector('#gbsSohcObdExt');
    if (sohcObdStd) {
      sohcObdStd.addEventListener('click', function () {
        var idx = state.features.indexOf('obd');
        if (idx !== -1) state.features.splice(idx, 1);
        if (sohcObdStd) sohcObdStd.classList.add('is-selected');
        if (sohcObdExt) sohcObdExt.classList.remove('is-selected');
      });
    }
    if (sohcObdExt) {
      sohcObdExt.addEventListener('click', function () {
        if (state.features.indexOf('obd') === -1) state.features.push('obd');
        if (sohcObdExt) sohcObdExt.classList.add('is-selected');
        if (sohcObdStd) sohcObdStd.classList.remove('is-selected');
      });
    }

    /* SOHC: Build details done button */
    var sohcVehicleDone = card.querySelector('#gbsSohcVehicleDone');
    if (sohcVehicleDone) {
      sohcVehicleDone.addEventListener('click', function () {
        var info     = state.sohcVehicleInfo || {};
        var isOther  = state.sohcEngine === 'other-sohc';
        var errors   = [];
        if (isOther) {
          if (!info.vehicleMake  || !info.vehicleMake.trim())  errors.push('gbsSohcVehicleMake');
          if (!info.vehicleModel || !info.vehicleModel.trim()) errors.push('gbsSohcVehicleModel');
          if (!info.originalEngine || !info.originalEngine.trim()) errors.push('gbsSohcOrigEngine');
        }
        if (!info.vehicleYear || !info.vehicleYear.trim()) errors.push('gbsSohcYear');

        var prevErr = card.querySelector('.gbs-feat-error');
        if (prevErr) prevErr.remove();

        if (errors.length > 0) {
          var firstEl = card.querySelector('#' + errors[0]);
          if (firstEl) { firstEl.classList.add('is-error'); firstEl.focus(); }
          var errEl = document.createElement('p');
          errEl.className = 'gbs-feat-error';
          errEl.textContent = 'Please complete all required fields above.';
          sohcVehicleDone.parentNode.insertBefore(errEl, sohcVehicleDone);
          return;
        }

        var summaryLabel = isOther
          ? esc((info.vehicleMake || '') + ' ' + (info.vehicleModel || '')) + ' (' + esc(info.vehicleYear || '') + ')'
          : (state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? esc(SOHC_COMPAT[state.sohcEngine].label) : '') + ' (' + esc(info.vehicleYear || '') + ')';
        collapseStep(card, stepId, summaryLabel);
        showResults();
      });
    }

    var done = card.querySelector('#gbsFeatDone');
    if (done) {
      done.addEventListener('click', function () {
        var isV8 = state.engineFamily !== 'barra-6cyl';
        if (isV8) {
          collapseStep(card, stepId, featLabel());
          showResults();
          return;
        }

        /* 6-cyl validation */
        var hasClusterNow  = state.features.indexOf('cluster') !== -1;
        var hasAcNow       = state.features.indexOf('ac')      !== -1;
        var needsCanbarraV = hasAcNow || hasClusterNow || state.transmission === 'zf';
        var errors = [];
        if (hasClusterNow  && !state.clusterInfo.clusterType.trim())          errors.push('gbsClusterType');
        if (needsCanbarraV && !state.canbarraInfo.vehicleMakeModel.trim())    errors.push('gbsCanbarraMakeModel');
        if (needsCanbarraV && !state.canbarraInfo.year.trim())                errors.push('gbsCanbarraYear');
        if (needsCanbarraV && !state.canbarraInfo.originalEngine.trim())      errors.push('gbsCanbarraEngine');

        var prevErr = card.querySelector('.gbs-feat-error');
        if (prevErr) prevErr.remove();

        if (errors.length > 0) {
          var firstEl = card.querySelector('#' + errors[0]);
          if (firstEl) {
            firstEl.classList.add('is-error');
            firstEl.focus();
            setTimeout(function () { firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
          }
          var msgs = {
            'gbsClusterType':      'Please enter your factory cluster type to continue.',
            'gbsCanbarraMakeModel':'Please enter your vehicle make and model for CANBarra configuration.',
            'gbsCanbarraYear':     'Please enter your vehicle year for CANBarra configuration.',
            'gbsCanbarraEngine':   'Please enter your original engine for CANBarra configuration.'
          };
          var errEl = document.createElement('p');
          errEl.className = 'gbs-feat-error';
          errEl.textContent = msgs[errors[0]] || 'Please complete the required fields above.';
          done.parentNode.insertBefore(errEl, done);
          return;
        }

        collapseStep(card, stepId, featLabel());
        showResults();
      });
    }
  }

  /* ================================================================
     SELECTION HANDLER
  ================================================================ */
  function onSelect(card, key, value, stepId) {
    card.querySelectorAll('[data-key="' + key + '"]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    var selEl = card.querySelector('[data-key="' + key + '"][data-value="' + value + '"]');
    if (selEl) selEl.classList.add('is-selected');

    state[key] = value;
    clearAfter(stepId);

    if (key === 'vehicle' && value === '__other__') {
      var otherPanel = card.querySelector('#gbsOtherVehicle');
      if (otherPanel) {
        otherPanel.hidden = false;
        var inp = card.querySelector('#gbsOtherInput');
        if (inp) setTimeout(function () { inp.focus(); }, 50);
      }
      return;
    }

    if (key === 'engine' && value === 'fg-mk2') {
      showFgMk2Block(card, stepId);
      return;
    }

    if (key === 'transmission' && state.engineFamily === 'barra-6cyl') {
      var oldZf = card.querySelector('.gbs-zf-block');
      if (oldZf) oldZf.remove();
      if (value === 'zf') {
        showZfBlock(card, stepId);
        return;
      }
    }

    if (key === 'sohcEngine' && value === 'unsure-sohc') {
      showSohcUnsureBlock(card);
      return;
    }

    if (key === 'sohcTransmission' && value === 'unsure') {
      var oldWarn = card.querySelector('.gbs-sohc-trans-warn');
      if (oldWarn) oldWarn.remove();
      var warn = document.createElement('div');
      warn.className = 'gbs-sohc-trans-warn';
      warn.innerHTML =
        '<p class="gbs-sohc-trans-warn__text"><strong>Not sure about your transmission?</strong> Select your best guess above, or contact us and we can help identify the correct option for your build.</p>' +
        '<a href="/pages/contact" class="gbs-sohc-trans-warn__link">Contact Us &#8594;</a>';
      var body = card.querySelector('.gbs-step__body');
      if (body) body.appendChild(warn);
    }

    setTimeout(function () {
      collapseStep(card, stepId, displayLabel(key, value));
      if (stepId < TOTAL_STEPS) {
        activeStep = stepId + 1;
        renderProgress();
        appendStep(stepId + 1);
        setTimeout(function () {
          var next = document.getElementById('gbsStep' + (stepId + 1));
          if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 200);
      }
    }, 320);
  }

  /* ================================================================
     HARD-STOP BLOCKS
  ================================================================ */
  function showFgMk2Block(card, stepId) {
    var old = card.querySelector('.gbs-fgmk2-block');
    if (old) old.remove();
    var block = document.createElement('div');
    block.className = 'gbs-fgmk2-block';
    block.innerHTML =
      '<div class="gbs-fgmk2-block__warn">' +
        '<strong class="gbs-fgmk2-block__title">&#9940; FG Mk2 ECU Services Are Not Currently Supported</strong>' +
        '<p class="gbs-fgmk2-block__msg">Greens Barra Solutions can supply wiring harnesses for FG Mk2 Barra engines. However ECU unlocks, ECU supply, PATS removal and standalone ECU configuration are not currently offered for FG Mk2.</p>' +
        '<p class="gbs-fgmk2-block__msg">If you require ECU services for an FG Mk2 please contact us directly.</p>' +
      '</div>' +
      '<a href="/pages/contact" class="gbs-fgmk2-block__contact">Contact Us About FG Mk2 &#8594;</a>' +
      '<button class="gbs-fgmk2-block__btn" id="gbsFgMk2Proceed" type="button">View Available FG Mk2 Harness Options &#8594;</button>';
    var body = card.querySelector('.gbs-step__body');
    if (body) body.appendChild(block);
    setTimeout(function () { block.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);
    var proceedBtn = document.getElementById('gbsFgMk2Proceed');
    if (proceedBtn) {
      proceedBtn.addEventListener('click', function () {
        collapseStep(card, stepId, displayLabel('engine', 'fg-mk2'));
        activeStep = TOTAL_STEPS + 1;
        renderProgress();
        showResults();
      });
    }
  }

  function showSohcUnsureBlock(card) {
    var old = card.querySelector('.gbs-sohc-unsure-block');
    if (old) old.remove();
    var block = document.createElement('div');
    block.className = 'gbs-sohc-unsure-block';
    block.innerHTML =
      '<div class="gbs-fgmk2-block__warn">' +
        '<strong class="gbs-fgmk2-block__title">&#128222; Not Sure? Let Us Help</strong>' +
        '<p class="gbs-fgmk2-block__msg">If you are not sure which SOHC engine or vehicle applies to your build, contact us directly. We can confirm compatibility and recommend the correct conversion kit for your application.</p>' +
      '</div>' +
      '<a href="/pages/contact" class="gbs-fgmk2-block__contact">Contact Us &#8594;</a>';
    var body = card.querySelector('.gbs-step__body');
    if (body) body.appendChild(block);
    setTimeout(function () { block.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);
  }

  function showZfBlock(card, stepId) {
    var block = document.createElement('div');
    block.className = 'gbs-zf-block';
    block.innerHTML =
      '<div class="gbs-zf-block__warn">' +
        '<strong class="gbs-zf-block__title">&#9888;&#65039; ZF Automatic — Important Notes</strong>' +
        '<ul class="gbs-zf-block__list">' +
          '<li><strong>ZF body loom required:</strong> You must supply your own ZF body loom — it must be sent to us before we can build your harness. It must match your vehicle model and be a 6-speed ZF body loom.</li>' +
          '<li><strong>CANBarra module required:</strong> A CANBarra module ($617.50) is mandatory for ZF Automatic compatibility and will be added to your order automatically.</li>' +
          '<li><strong>Cruise control, air conditioning, and factory dash integration included:</strong> ZF Automatic harnesses include cruise control and air conditioning wiring as standard, and factory dash integration is handled via the required CANBarra module — none of these need to be added as separate features.</li>' +
        '</ul>' +
      '</div>' +
      '<button class="gbs-zf-block__btn" id="gbsZfProceed" type="button">I Understand — Continue &#8594;</button>';
    var body = card.querySelector('.gbs-step__body');
    if (body) body.appendChild(block);
    setTimeout(function () { block.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);

    var proceedBtn = block.querySelector('#gbsZfProceed');
    if (proceedBtn) {
      proceedBtn.addEventListener('click', function () {
        collapseStep(card, stepId, 'ZF Automatic');
        if (stepId < TOTAL_STEPS) {
          activeStep = stepId + 1;
          renderProgress();
          appendStep(stepId + 1);
          setTimeout(function () {
            var next = document.getElementById('gbsStep' + (stepId + 1));
            if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 200);
        }
      });
    }
  }

  /* ================================================================
     STEP COLLAPSE / EDIT
  ================================================================ */
  function collapseStep(card, stepId, summaryText) {
    card.classList.add('is-complete');
    var body = card.querySelector('.gbs-step__body');
    if (!body) return;
    body.innerHTML =
      '<div class="gbs-step__summary">' +
        '<span class="gbs-step__summary-value">' + esc(summaryText) + '</span>' +
        '<button class="gbs-step__edit-btn" type="button">Edit</button>' +
      '</div>';
    body.querySelector('.gbs-step__edit-btn').addEventListener('click', function () {
      editStep(card, stepId);
    });
  }

  function editStep(card, stepId) {
    for (var i = stepId - 1; i < ACTIVE_STATE_KEYS.length; i++) {
      state[ACTIVE_STATE_KEYS[i]] = resetKey(ACTIVE_STATE_KEYS[i]);
    }
    card.classList.remove('is-complete');
    var step = getStep(stepId);
    if (step) {
      var titleEl = card.querySelector('.gbs-step__title');
      if (titleEl && step.type === 'ecu') {
        titleEl.innerHTML = isTurboEngine() ? 'Turbo ECU &amp; Boost Control' : step.title;
      }
      card.querySelector('.gbs-step__body').innerHTML = buildBody(step);
    }
    bindListeners(card, stepId);
    clearAfter(stepId);
    if (resultsEl) resultsEl.hidden = true;
    if (restartEl) restartEl.hidden = true;
    activeStep = stepId;
    renderProgress();
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function resetKey(k) {
    if (k === 'features')        return [];
    if (k === 'sohcVehicleInfo') return { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' };
    return null;
  }

  function clearAfter(stepId) {
    for (var s = stepId + 1; s <= TOTAL_STEPS; s++) {
      var el = document.getElementById('gbsStep' + s);
      if (el) el.remove();
    }
    for (var i = stepId; i < ACTIVE_STATE_KEYS.length; i++) {
      state[ACTIVE_STATE_KEYS[i]] = resetKey(ACTIVE_STATE_KEYS[i]);
    }
  }

  /* ================================================================
     LABEL HELPERS
  ================================================================ */
  function displayFamilyLabel(family) {
    if (family === 'barra-6cyl')    return 'Barra 6 Cylinder';
    if (family === 'barra-v8')      return 'Barra V8';
    if (family === 'boss-v8')       return 'Boss V8';
    if (family === 'sohc-barra-ecu') return 'Barra ECU to SOHC Conversion';
    return family || '';
  }

  function displayLabel(key, value) {
    switch (key) {
      case 'vehicle':      return findLabel(flatVehicles(), value) || value;
      case 'engine':       return findLabel(ENGINES, value);
      case 'bossVariant':  return findLabel(BOSS_VARIANTS, value);
      case 'transmission': return findLabel(TRANSMISSIONS.concat(V8_TRANSMISSIONS), value);
      case 'harnessStyle': return value === 'standalone' ? 'Standalone Harness' : 'Integration Harness';
      case 'ecu':
        if (value === 'have-no-service') return 'Have ECU — No Service Required';
        if (value === 'have-mail-in')    return 'Have ECU — Mail-In Programming';
        if (value === 'need')            return 'GBS to Supply & Program ECU';
        if (value === 'factory-turbo')   return 'Factory Turbo ECU';
        if (value === 'na-ecu')          return 'N/A ECU — External Boost';
        if (value === 'need-supply')     return 'GBS to Supply ECU';
        if (value === 'not-sure')        return 'Not Sure — Discuss With Team';
        if (value === 'ecu-unsure')      return 'Not Sure — To Be Confirmed';
        return value;
      case 'sohcEcuGen':
        if (value === 'ba') return 'BA Barra ECU';
        return value;
      case 'sohcEngine':
        return (SOHC_COMPAT[value] && SOHC_COMPAT[value].label) ? SOHC_COMPAT[value].label : value;
      case 'sohcTransmission':
        return SOHC_TRANS_LABELS[value] || value;
      default: return value;
    }
  }

  function findLabel(list, value) {
    for (var i = 0; i < list.length; i++) { if (list[i].value === value) return list[i].label; }
    return value;
  }
  function flatVehicles() {
    var all = [];
    VEHICLES.forEach(function (g) { all = all.concat(g.options); });
    return all;
  }
  function featLabel() {
    return state.features.length === 0 ? 'No additional features selected'
      : state.features.map(function (v) { return findLabel(FEATURES, v); }).join(', ');
  }
  function getStep(id) {
    for (var i = 0; i < ACTIVE_STEPS.length; i++) { if (ACTIVE_STEPS[i].id === id) return ACTIVE_STEPS[i]; }
    return null;
  }

  /* ================================================================
     RECOMMENDATION ENGINE  (6-cyl only)
  ================================================================ */
  function generateRecommendation() {
    var engine     = state.engine;
    var trans      = state.transmission;
    var features   = state.features;
    var isFgMk2    = engine === 'fg-mk2';
    var isTurboEng = engine && engine.indexOf('turbo') !== -1;
    var hasAc      = features.indexOf('ac')      !== -1;
    var hasCruise  = features.indexOf('cruise')  !== -1;
    var hasCluster = features.indexOf('cluster') !== -1;
    var usesTurboVariant = isTurboEng && state.ecu === 'factory-turbo';

    var items = [];
    var notes = [];

    /* 1. Harness */
    var harnessKey     = (state.harnessStyle === 'integration') ? 'integrationHarness' : 'standaloneHarness';
    var harnessTypeLbl = usesTurboVariant ? 'Turbo Ready' : 'Standard';
    items.push({
      key:    harnessKey,
      reason: harnessTypeLbl + ' harness required for your ' + displayLabel('vehicle', state.vehicle) + ' running a ' + displayLabel('engine', engine) + ' engine.',
      qty:    1
    });

    /* 2. ECU */
    if (!isFgMk2) {
      if (isTurboEng) {
        if (state.ecu === 'factory-turbo') {
          items.push({ key: 'mailInEcu', reason: 'Your factory turbo ECU will be unlocked, PATS removed, and configured for standalone operation with factory boost control retained.', qty: 1 });
        } else if (state.ecu === 'na-ecu') {
          items.push({ key: 'mailInEcu', reason: 'Your N/A ECU will be unlocked, PATS removed, and configured for standalone operation. External boost control will be required.', qty: 1 });
        } else if (state.ecu === 'need-supply') {
          items.push({ key: 'suppliedEcu', reason: 'Greens Barra Solutions will source and program a naturally aspirated Barra ECU for your standalone conversion.', qty: 1 });
        }
      } else {
        if (state.ecu === 'have-mail-in') {
          items.push({ key: 'mailInEcu', reason: 'Your Barra ECU will have PATS removed and be configured for standalone operation. Send it to us for programming.', qty: 1 });
        } else if (state.ecu === 'need') {
          items.push({ key: 'suppliedEcu', reason: 'Greens Barra Solutions will source and program a Barra ECU for your standalone conversion.', qty: 1 });
        }
      }
    }

    /* 3. CANbarra */
    if (hasAc || hasCluster || trans === 'zf') {
      var reasons = [];
      if (trans === 'zf')  reasons.push('ZF Automatic transmission compatibility');
      if (hasAc)           reasons.push('retaining air conditioning');
      if (hasCluster)      reasons.push('retaining the factory instrument cluster');
      items.push({ key: 'canbarra', reason: 'Required for ' + reasons.join(' and ') + '. The Barra ECU communicates with factory body modules via CAN bus.', qty: 1 });
    }

    /* 4. Aftermarket Dash Provision */
    if (state.dashProvision === true) {
      items.push({ key: 'aftermarketDash', reason: 'Aftermarket dash provision wiring added to your harness — plug-and-play connection' + (state.dashModel ? ' for your ' + state.dashModel : '') + '.', qty: 1 });
    }

    /* Notes */
    if (isFgMk2) {
      notes.push({ type: 'error', text: 'ECU programming services are not currently available for FG Mk2 engines. A conversion harness can still be supplied — contact us for FG Mk2 ECU options.' });
    }
    if (isTurboEng && !isFgMk2) {
      if (state.ecu === 'factory-turbo') {
        notes.push({ type: 'info', text: 'A Turbo Ready Harness has been recommended because you are retaining a genuine factory turbo ECU with factory ECU-controlled boost.' });
      } else if (state.ecu === 'na-ecu') {
        notes.push({ type: 'info', text: 'A Standard Harness has been recommended. Factory ECU-controlled boost is not available when using an N/A ECU — external boost control will be required.' });
      } else if (state.ecu === 'need-supply') {
        notes.push({ type: 'warning', text: 'Greens Barra Solutions currently supplies naturally aspirated ECUs only. Factory turbo boost control is NOT available with a supplied ECU. A Standard Harness has been recommended. If factory ECU boost control is required, you will need to source a genuine factory turbo ECU and use the Mail-In ECU Service instead.' });
      } else if (state.ecu === 'not-sure') {
        notes.push({ type: 'warning', text: 'A Standard Harness has been selected by default. If you later source a genuine factory turbo ECU before your harness is built, contact Greens Barra Solutions to upgrade your order to a Turbo Ready Harness.' });
        notes.push({ type: 'info', text: 'No ECU service has been included as your ECU situation is still to be determined. Contact us once you have identified your ECU.' });
      }
    }
    if (trans === 'zf') {
      notes.push({ type: 'warning', text: 'ZF Automatic: You must supply your own ZF body loom — it must be sent to us before we can build your harness. It must match your vehicle model and be a 6-speed ZF body loom.' });
      notes.push({ type: 'info', text: 'A CANBarra module ($617.50) has been automatically added to your order — it is required for ZF Automatic transmission compatibility.' });
    }
    if (trans === 'btr') {
      notes.push({ type: 'info', text: 'BTR automatics require an OSS (Output Shaft Speed) signal to the ECU unless an aftermarket transmission controller is used.' });
    }
    if (trans === 'aftermarket-tc') {
      notes.push({ type: 'info', text: 'OSS speed signal is not required when using an aftermarket transmission controller.' });
    }
    if (hasCruise) {
      notes.push({ type: 'info', text: 'Cruise control requires a vehicle speed input to the ECU. The required setup depends on your vehicle and transmission combination — we\'ll review this with your order.' });
    }

    return { items: items, notes: notes };
  }

  /* ================================================================
     VARIANT RESOLUTION
  ================================================================ */
  function resolveAllVariants(keys, callback) {
    var seen = {};
    var toFetch = [];
    keys.forEach(function (key) {
      if (seen[key]) return;
      seen[key] = true;
      var p = PRODUCTS[key];
      if (p && p.handle && !p._variants) toFetch.push(key);
    });
    if (toFetch.length === 0) { callback(); return; }
    var pending = toFetch.length;
    function done() { if (--pending === 0) callback(); }
    toFetch.forEach(function (key) {
      var p = PRODUCTS[key];
      fetch('/products/' + p.handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) { p._variants = data.variants; p._shopifyTitle = data.title; p._url = '/products/' + data.handle; })
        .catch(function () { p._variants = []; })
        .then(done);
    });
  }

  function pickVariant(key) {
    var p = PRODUCTS[key];
    if (!p || !p._variants || p._variants.length === 0) return null;
    var variants = p._variants;
    if (variants.length === 1) return variants[0];

    var engine    = state.engine || '';
    var hasAc     = state.features.indexOf('ac')     !== -1;
    var hasCruise = state.features.indexOf('cruise') !== -1;
    var hasObd    = state.features.indexOf('obd')    !== -1;
    var needsAcCruise = hasAc || hasCruise;
    var isTurboVariant    = state.ecu === 'factory-turbo';
    var isFactoryTurboEcu = state.ecu === 'factory-turbo';

    var series;
    if (engine.indexOf('fg') !== -1)      series = 'FG';
    else if (engine.indexOf('bf') !== -1) series = 'BF';
    else                                  series = 'BA';

    if (key === 'sohcHarnessStandalone' || key === 'sohcHarnessIntegration') {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].title.toLowerCase().indexOf('ba') !== -1) return variants[i];
      }
      return variants[0];
    }

    if (key === 'standaloneHarness' || key === 'integrationHarness') {
      /* ZF Automatic — match the ZF-specific variant before the standard logic */
      if (state.transmission === 'zf') {
        /* isTurboVariant already defined: state.ecu === 'factory-turbo' */
        for (var i = 0; i < variants.length; i++) {
          var t = variants[i].title.toLowerCase();
          if (t.indexOf('zf') === -1) continue;
          if (t.indexOf('fg') === -1) continue;  /* ZF is FG series */
          var isExtended = t.indexOf('2m extended') !== -1;
          if (hasObd && !isExtended) continue;
          if (!hasObd && isExtended) continue;
          var hasTurbo = t.indexOf('turbo') !== -1;
          if (isTurboVariant && !hasTurbo) continue;
          if (!isTurboVariant && hasTurbo) continue;
          return variants[i];
        }
        /* Fallback: first ZF variant of matching turbo status */
        for (var i = 0; i < variants.length; i++) {
          var t = variants[i].title.toLowerCase();
          if (t.indexOf('zf') === -1) continue;
          var hasTurbo = t.indexOf('turbo') !== -1;
          if (isTurboVariant === hasTurbo) return variants[i];
        }
        /* Final fallback: any ZF variant */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].title.toLowerCase().indexOf('zf') !== -1) return variants[i];
        }
      }

      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title.toLowerCase();
        if (t.indexOf(series.toLowerCase()) === -1) continue;
        var isExtended = t.indexOf('2m extended') !== -1;
        if (hasObd && !isExtended) continue;
        if (!hasObd && isExtended) continue;
        var hasT = t.indexOf('turbo') !== -1;
        var hasC = t.indexOf('cruise') !== -1 || t.indexOf('a/c') !== -1;
        if (isTurboVariant && needsAcCruise && hasT && hasC)     return variants[i];
        if (isTurboVariant && !needsAcCruise && hasT && !hasC)   return variants[i];
        if (!isTurboVariant && needsAcCruise && !hasT && hasC)   return variants[i];
        if (!isTurboVariant && !needsAcCruise && !hasT && !hasC) return variants[i];
      }
      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title.toLowerCase();
        var isExtended = t.indexOf('2m extended') !== -1;
        if (t.indexOf(series.toLowerCase()) !== -1 && (hasObd ? isExtended : !isExtended)) return variants[i];
      }
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].title.toLowerCase().indexOf(series.toLowerCase()) !== -1) return variants[i];
      }
    }
    if (key === 'suppliedEcu') {
      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title.toLowerCase();
        if (t.indexOf(series.toLowerCase()) === -1) continue;
        if (t.indexOf('n/a standalone') !== -1) return variants[i];
      }
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].title.toLowerCase().indexOf(series.toLowerCase()) !== -1) return variants[i];
      }
    }
    if (key === 'mailInEcu') {
      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title.toLowerCase();
        if (t.indexOf(series.toLowerCase()) === -1) continue;
        if (isFactoryTurboEcu  && t.indexOf('turbo ready') !== -1)    return variants[i];
        if (!isFactoryTurboEcu && t.indexOf('n/a standalone') !== -1) return variants[i];
      }
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].title.toLowerCase().indexOf(series.toLowerCase()) !== -1) return variants[i];
      }
    }
    if (key === 'canbarra') {
      /* ZF builds require the ZF-specific CANBarra variant */
      if (state.transmission === 'zf') {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].title.toLowerCase().indexOf('zf') !== -1) return variants[i];
        }
      } else {
        /* Standard builds use the non-ZF variant */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].title.toLowerCase().indexOf('zf') === -1) return variants[i];
        }
      }
    }
    return variants[0];
  }

  function formatMoney(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ================================================================
     RESULTS
  ================================================================ */
  function showResults() {
    var isV8 = state.engineFamily !== 'barra-6cyl';
    if (isV8) { showV8Results(); return; }
    if (state.engineFamily === 'sohc-barra-ecu') { showSohcResults(); return; }

    var rec = generateRecommendation();
    cartItems = rec.items.map(function (item) {
      return { key: item.key, reason: item.reason, qty: item.qty, removed: false };
    });
    if (!resultsEl) return;
    resultsEl.innerHTML =
      '<div class="gbs-results__loading">' +
        '<div class="gbs-results__spinner"></div>' +
        '<p>Building your recommended setup…</p>' +
      '</div>';
    resultsEl.hidden = false;
    if (restartEl) restartEl.hidden = false;
    activeStep = TOTAL_STEPS + 1;
    renderProgress();
    setTimeout(function () { resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    var keys = cartItems.map(function (i) { return i.key; });
    resolveAllVariants(keys, function () {
      resultsEl.innerHTML = buildResultsHTML(rec.notes);
      bindResultsListeners();
      updateAtcCount();
    });
  }

  /* ── V8 / Boss V8 contact-required results ───────────────────── */
  function showV8Results() {
    if (!resultsEl) return;
    activeStep = TOTAL_STEPS + 1;
    renderProgress();
    resultsEl.innerHTML = buildV8ResultsHTML();
    resultsEl.hidden = false;
    if (restartEl) restartEl.hidden = false;
    setTimeout(function () { resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
  }

  function buildV8ResultsHTML() {
    var familyLabel = displayFamilyLabel(state.engineFamily);
    var contactUrl  = buildV8ContactUrl();
    var h = '';

    h += '<div class="gbs-results__header">';
    h +=   '<p class="gbs-results__tag">Your Configuration</p>';
    h +=   '<h2 class="gbs-results__title">' + esc(familyLabel) + ' Build</h2>';
    h +=   '<p class="gbs-results__intro">Your build configuration has been captured below. Contact us directly to discuss your build and receive a custom quote.</p>';
    h += '</div>';

    h += '<div class="gbs-v8-contact-card">';
    h +=   '<div class="gbs-v8-contact-card__icon">&#128233;</div>';
    h +=   '<h3 class="gbs-v8-contact-card__title">Contact Required to Order</h3>';
    h +=   '<p class="gbs-v8-contact-card__desc">' +
             esc(familyLabel) + ' conversion harnesses and components are not currently available to order directly through the Barra Builder. ' +
             'We\'ll work with you to design and build the correct harness and components for your specific build.' +
           '</p>';
    h +=   '<a href="' + esc(contactUrl) + '" class="gbs-v8-contact-card__btn">Contact Us About Your ' + esc(familyLabel) + ' Build &#8594;</a>';
    h += '</div>';

    h += buildConfigSummaryHTML();

    h += '<div class="gbs-results__contact">';
    h +=   '<p>We\'ll review your configuration and be in touch to discuss next steps, pricing and build timeframe.</p>';
    h +=   '<a href="/pages/contact" class="gbs-cta gbs-cta--outline">Contact Greens Barra Solutions &#8594;</a>';
    h += '</div>';

    return h;
  }

  function buildV8ContactUrl() {
    var params = [];
    params.push('engine_family=' + encodeURIComponent(displayFamilyLabel(state.engineFamily)));
    if (state.vehicle)      params.push('vehicle='      + encodeURIComponent(displayLabel('vehicle',      state.vehicle)));
    if (state.bossVariant)  params.push('boss_variant=' + encodeURIComponent(displayLabel('bossVariant',  state.bossVariant)));
    if (state.transmission) params.push('transmission=' + encodeURIComponent(displayLabel('transmission', state.transmission)));
    if (state.harnessStyle) params.push('harness='      + encodeURIComponent(displayLabel('harnessStyle', state.harnessStyle)));
    if (state.ecu)          params.push('ecu='          + encodeURIComponent(displayLabel('ecu',          state.ecu)));
    if (state.features.length > 0) params.push('features=' + encodeURIComponent(featLabel()));
    return '/pages/contact?' + params.join('&');
  }

  /* ── SOHC results ────────────────────────────────────────────── */
  function generateSohcRecommendation() {
    var items = [];
    var harnessKey = (state.harnessStyle === 'integration') ? 'sohcHarnessIntegration' : 'sohcHarnessStandalone';
    var info = state.sohcVehicleInfo || {};
    var engineLabel = state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? SOHC_COMPAT[state.sohcEngine].label : '';
    var vehicleStr = state.sohcEngine === 'other-sohc'
      ? ((info.vehicleMake || '') + ' ' + (info.vehicleModel || '')).trim()
      : engineLabel;
    items.push({
      key:    harnessKey,
      reason: 'SOHC Barra ECU conversion harness' + (vehicleStr ? ' for your ' + vehicleStr + ' build' : '') + '.',
      qty:    1
    });
    if (state.ecu === 'need') {
      items.push({ key: 'suppliedEcu', reason: 'Greens Barra Solutions will source and program a Barra ECU for standalone operation with your SOHC engine.', qty: 1 });
    } else if (state.ecu === 'have-mail-in') {
      items.push({ key: 'mailInEcu', reason: 'Your Barra ECU will have PATS removed and be configured for standalone operation with your SOHC engine.', qty: 1 });
    }
    if (state.dashProvision === true) {
      items.push({ key: 'aftermarketDash', reason: 'Aftermarket dash provision wiring added to your SOHC harness — plug-and-play connection' + (state.dashModel ? ' for your ' + state.dashModel : '') + '.', qty: 1 });
    }
    return { items: items };
  }

  function showSohcResults() {
    var rec = generateSohcRecommendation();
    cartItems = rec.items.map(function (item) {
      return { key: item.key, reason: item.reason, qty: item.qty, removed: false };
    });
    if (!resultsEl) return;
    resultsEl.innerHTML =
      '<div class="gbs-results__loading">' +
        '<div class="gbs-results__spinner"></div>' +
        '<p>Building your recommended setup&#8230;</p>' +
      '</div>';
    resultsEl.hidden = false;
    if (restartEl) restartEl.hidden = false;
    activeStep = TOTAL_STEPS + 1;
    renderProgress();
    setTimeout(function () { resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    var keys = cartItems.map(function (i) { return i.key; });
    resolveAllVariants(keys, function () {
      resultsEl.innerHTML = buildSohcResultsHTML();
      bindResultsListeners();
      updateAtcCount();
    });
  }

  function buildSohcResultsHTML() {
    var h = '';
    h += '<div class="gbs-results__header">';
    h +=   '<p class="gbs-results__tag">SOHC Barra ECU Conversion</p>';
    h +=   '<h2 class="gbs-results__title">Your Recommended Setup</h2>';
    h +=   '<p class="gbs-results__intro">Everything below is pre-selected for your SOHC Barra ECU conversion. Remove anything you don\'t want, then add the rest to your cart.</p>';
    h += '</div>';

    h += buildSohcBenefitsHTML();

    if (cartItems.length === 0) {
      h += '<div class="gbs-notes-card"><p class="gbs-note gbs-note--info">We couldn\'t determine a specific recommendation. Please <a href="/pages/contact" style="color:inherit">contact us</a> and we\'ll help directly.</p></div>';
    } else {
      cartItems.forEach(function (item) {
        var p = PRODUCTS[item.key];
        if (!p) return;
        var variant      = pickVariant(item.key);
        var variantLabel = variant ? variant.title : null;
        var price        = variant ? formatMoney(variant.price) : null;
        var title        = p._shopifyTitle || p.title;
        var baseUrl      = p._url || ('/products/' + p.handle);
        var url          = variant ? (baseUrl + '?variant=' + variant.id) : baseUrl;
        /* CANBarra is required (non-removable) for ZF builds */
        var locked = item.key === 'canbarra' && state.transmission === 'zf';
        h += recCard(item.key, p.badge, title, item.reason, price, variantLabel, url, locked);
      });
    }

    h += '<div class="gbs-atc-section" id="gbsAtcSection">';
    h +=   '<p class="gbs-atc-count" id="gbsAtcCount"></p>';
    h +=   '<button class="gbs-atc-btn" id="gbsAtcBtn" type="button">Add Recommended Setup To Cart</button>';
    h +=   '<p class="gbs-atc-note">You can remove individual items from your cart at any time after adding</p>';
    h += '</div>';

    h += buildSohcConfigSummaryHTML();

    h += '<div class="gbs-results__contact">';
    h +=   '<p>Not sure about something? We\'re happy to help before you order.</p>';
    h +=   '<a href="/pages/contact" class="gbs-cta gbs-cta--outline">Contact Us &#8594;</a>';
    h += '</div>';

    return h;
  }

  function buildSohcBenefitsHTML() {
    var benefits = [
      { icon: '&#128268;', title: 'Modern Factory Ford PCM',      desc: 'Run your SOHC on the latest factory Ford engine management technology.' },
      { icon: '&#128295;', title: 'PCMTEC Tuning Support',        desc: 'Full support for professional PCMTEC tuning for your engine.' },
      { icon: '&#128200;', title: 'Better OBDII Diagnostics',     desc: 'Full factory OBDII diagnostics — plug in any scan tool and read fault codes.' },
      { icon: '&#9989;',   title: 'Factory ECU Reliability',      desc: 'Proven factory reliability with thousands of hours of engineering behind it.' },
      { icon: '&#9981;',   title: 'ECU-Controlled Fuel Pump',     desc: 'Fuel pump control handled natively by the Barra PCM for optimal operation.' },
      { icon: '&#127777;', title: 'ECU-Controlled Thermo Fans',   desc: 'Temperature-controlled thermo fans managed directly by the ECU.' },
      { icon: '&#128196;', title: 'Future Tuning Flexibility',    desc: 'Tune now and re-tune later as your build evolves — the platform grows with you.' },
      { icon: '&#9889;',   title: 'Clean Standalone Wiring',      desc: 'Purpose-built standalone loom keeps your engine bay tidy and professional.' }
    ];
    var h = '<div class="gbs-sohc-benefits">';
    h += '<p class="gbs-sohc-benefits__heading">Why Run a Barra ECU on Your SOHC Engine?</p>';
    h += '<div class="gbs-sohc-benefits__grid">';
    benefits.forEach(function (b) {
      h += '<div class="gbs-sohc-benefit">';
      h +=   '<span class="gbs-sohc-benefit__icon">' + b.icon + '</span>';
      h +=   '<div>';
      h +=     '<p class="gbs-sohc-benefit__title">' + b.title + '</p>';
      h +=     '<p class="gbs-sohc-benefit__desc">' + b.desc + '</p>';
      h +=   '</div>';
      h += '</div>';
    });
    h += '</div></div>';
    return h;
  }

  function buildSohcConfigSummaryHTML() {
    var info = state.sohcVehicleInfo || {};
    var hasObd = state.features.indexOf('obd') !== -1;
    var engineLabel = state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? SOHC_COMPAT[state.sohcEngine].label : (state.sohcEngine || '');
    var vehicleStr = state.sohcEngine === 'other-sohc'
      ? ((info.vehicleMake || '') + ' ' + (info.vehicleModel || '')).trim()
      : engineLabel;
    var retains = [];
    if (info.clusterRetain) retains.push('Cluster');
    if (info.acRetain)      retains.push('A/C');
    if (info.cruiseRetain)  retains.push('Cruise');
    var h = '<div class="gbs-summary-card">';
    h += '<p class="gbs-summary-card__heading">Your SOHC Build Configuration</p>';
    h += '<ul class="gbs-summary-list">';
    h += '<li><span>Conversion Type</span><span>SOHC Barra ECU Conversion</span></li>';
    if (engineLabel)          h += '<li><span>SOHC Engine</span><span>'      + esc(engineLabel) + '</span></li>';
    if (vehicleStr)           h += '<li><span>Vehicle</span><span>'          + esc(vehicleStr)  + '</span></li>';
    if (info.vehicleYear)     h += '<li><span>Year</span><span>'             + esc(info.vehicleYear) + '</span></li>';
    if (info.originalEngine && state.sohcEngine === 'other-sohc') h += '<li><span>Engine</span><span>' + esc(info.originalEngine) + '</span></li>';
    if (state.sohcTransmission) h += '<li><span>Transmission</span><span>'  + esc(displayLabel('sohcTransmission', state.sohcTransmission)) + '</span></li>';
    if (state.ecu)            h += '<li><span>ECU Service</span><span>'      + esc(displayLabel('ecu', state.ecu)) + '</span></li>';
    if (state.sohcEcuGen)     h += '<li><span>ECU Generation</span><span>'  + esc(displayLabel('sohcEcuGen', state.sohcEcuGen)) + '</span></li>';
    if (state.harnessStyle)   h += '<li><span>Loom Style</span><span>'      + esc(displayLabel('harnessStyle', state.harnessStyle)) + '</span></li>';
    h += '<li><span>OBDII Port</span><span>' + (hasObd ? 'Extended Into Cabin (+$25)' : 'Standard Location') + '</span></li>';
    if (retains.length)       h += '<li><span>Retain</span><span>'          + esc(retains.join(', ')) + '</span></li>';
    if (state.dashProvision === true) h += '<li><span>Dash Provision</span><span>' + (state.dashModel ? esc(state.dashModel) + ' (+$25)' : 'Yes (+$25)') + '</span></li>';
    if (info.ecuDetails)      h += '<li><span>ECU Part No.</span><span>'    + esc(info.ecuDetails) + '</span></li>';
    if (state.sohcEcuInfo)    h += '<li><span>ECU Gen Notes</span><span>'   + esc(state.sohcEcuInfo) + '</span></li>';
    if (info.notes)           h += '<li><span>Customer Notes</span><span>'  + esc(info.notes) + '</span></li>';
    h += '</ul></div>';
    return h;
  }

  function buildConfigSummaryHTML() {
    var hasObd = state.features.indexOf('obd') !== -1;
    var visibleFeatures = state.features.filter(function (v) { return v !== 'obd'; });
    var h = '<div class="gbs-summary-card">';
    h += '<p class="gbs-summary-card__heading">Your Build Configuration</p>';
    h += '<ul class="gbs-summary-list">';
    if (state.engineFamily)  h += '<li><span>Engine Family</span><span>' + esc(displayFamilyLabel(state.engineFamily)) + '</span></li>';
    if (state.vehicle)       h += '<li><span>Vehicle</span><span>'       + esc(displayLabel('vehicle',      state.vehicle))      + '</span></li>';
    if (state.engine)        h += '<li><span>Engine</span><span>'        + esc(displayLabel('engine',       state.engine))       + '</span></li>';
    if (state.bossVariant)   h += '<li><span>Boss Variant</span><span>'  + esc(displayLabel('bossVariant',  state.bossVariant))  + '</span></li>';
    if (state.transmission)  h += '<li><span>Transmission</span><span>'  + esc(displayLabel('transmission', state.transmission)) + '</span></li>';
    if (state.harnessStyle)  h += '<li><span>Harness</span><span>'       + esc(displayLabel('harnessStyle', state.harnessStyle)) + '</span></li>';
    if (state.ecu)           h += '<li><span>ECU</span><span>'           + esc(displayLabel('ecu',          state.ecu))          + '</span></li>';
    if (visibleFeatures.length > 0) h += '<li><span>Features</span><span>' + esc(visibleFeatures.map(function (v) { return findLabel(FEATURES, v); }).join(', ')) + '</span></li>';
    h += '<li><span>OBDII Port</span><span>' + (hasObd ? 'Extended into Cabin (+$25)' : 'Standard Location') + '</span></li>';
    if (state.dashProvision === true) h += '<li><span>Aftermarket Dash</span><span>' + (state.dashModel ? esc(state.dashModel) + ' (+$25)' : 'Yes (+$25)') + '</span></li>';
    h += '</ul>';
    h += '</div>';
    return h;
  }

  /* ── 6-cyl results HTML ──────────────────────────────────────── */
  function buildResultsHTML(notes) {
    var h = '';
    h += '<div class="gbs-results__header">';
    h +=   '<p class="gbs-results__tag">Based on your setup, we recommend:</p>';
    h +=   '<h2 class="gbs-results__title">Your Recommended Setup</h2>';
    h +=   '<p class="gbs-results__intro">Everything below is pre-selected for your build. Remove anything you don\'t want, then add the rest to your cart in one click.</p>';
    h += '</div>';

    if (cartItems.length === 0) {
      h += '<div class="gbs-notes-card"><p class="gbs-note gbs-note--info">We couldn\'t determine a specific recommendation. Please <a href="/pages/contact" style="color:inherit">contact us</a> and we\'ll help directly.</p></div>';
    } else {
      cartItems.forEach(function (item) {
        var p = PRODUCTS[item.key];
        if (!p) return;
        var variant      = pickVariant(item.key);
        var variantLabel = variant ? variant.title : null;
        var price        = variant ? formatMoney(variant.price) : null;
        var title        = p._shopifyTitle || p.title;
        var baseUrl      = p._url || ('/products/' + p.handle);
        var url          = variant ? (baseUrl + '?variant=' + variant.id) : baseUrl;
        /* CANBarra is required (non-removable) for ZF builds */
        var locked = item.key === 'canbarra' && state.transmission === 'zf';
        h += recCard(item.key, p.badge, title, item.reason, price, variantLabel, url, locked);
      });
    }

    h += '<div class="gbs-atc-section" id="gbsAtcSection">';
    h +=   '<p class="gbs-atc-count" id="gbsAtcCount"></p>';
    h +=   '<button class="gbs-atc-btn" id="gbsAtcBtn" type="button">Add Recommended Setup To Cart</button>';
    h +=   '<p class="gbs-atc-note">You can remove individual items from your cart at any time after adding</p>';
    h += '</div>';

    if (notes.length > 0) {
      h += '<div class="gbs-notes-card">';
      h +=   '<p class="gbs-notes-card__heading">&#128221; Important Notes</p>';
      notes.forEach(function (n) {
        h += '<div class="gbs-note gbs-note--' + n.type + '">' + esc(n.text) + '</div>';
      });
      h += '</div>';
    }

    h += buildConfigSummaryHTML();

    h += '<div class="gbs-results__contact">';
    h +=   '<p>Not sure about something? We\'re happy to help before you order.</p>';
    h +=   '<a href="/pages/contact" class="gbs-cta gbs-cta--outline">Contact Us &#8594;</a>';
    h += '</div>';

    return h;
  }

  function recCard(key, badge, title, reason, price, variantLabel, url, locked) {
    var priceHtml = price
      ? '<p class="gbs-rec-card__price">' + esc(price) + '</p>'
      : '<p class="gbs-rec-card__price gbs-rec-card__price--loading">Loading price…</p>';
    var variantHtml = variantLabel && variantLabel !== 'Default Title'
      ? '<span class="gbs-rec-card__variant">' + esc(variantLabel) + '</span>'
      : '';
    var removeHtml = locked
      ? '<span class="gbs-rec-card__required">Required</span>'
      : '<button class="gbs-rec-card__remove" type="button" aria-label="Remove from order">Remove</button>';
    return (
      '<div class="gbs-rec-card' + (locked ? ' gbs-rec-card--locked' : '') + '" id="gbsRec-' + esc(key) + '" data-key="' + esc(key) + '">' +
        '<div class="gbs-rec-card__top">' +
          '<span class="gbs-rec-card__badge">' + esc(badge) + '</span>' +
          removeHtml +
        '</div>' +
        '<div class="gbs-rec-card__removed-bar">' +
          '<span>Removed from your order</span>' +
          '<button class="gbs-rec-card__readd" type="button">Add back</button>' +
        '</div>' +
        '<h3 class="gbs-rec-card__title">' + esc(title) + '</h3>' +
        variantHtml +
        '<p class="gbs-rec-card__reason">' + esc(reason) + '</p>' +
        priceHtml +
        '<div class="gbs-rec-card__meta">' +
          '<span class="gbs-rec-card__qty">Qty: 1</span>' +
          '<a href="' + esc(url) + '" class="gbs-rec-card__link" target="_blank">View product details &#8594;</a>' +
        '</div>' +
      '</div>'
    );
  }

  /* ================================================================
     ITEM PROPERTIES BUILDER  (Prompt 5 — line-item properties)
  ================================================================ */
  function buildItemProperties(key, harnessTitle) {
    var hasAc      = state.features.indexOf('ac')      !== -1;
    var hasCruise  = state.features.indexOf('cruise')  !== -1;
    var hasCluster = state.features.indexOf('cluster') !== -1;
    var hasObd     = state.features.indexOf('obd')     !== -1;
    var props = {};

    var isHarness     = key === 'standaloneHarness' || key === 'integrationHarness';
    var isSohcHarness = key === 'sohcHarnessStandalone' || key === 'sohcHarnessIntegration';

    if (isHarness) {
      if (state.vehicle)      props['Conversion Vehicle']  = displayLabel('vehicle',      state.vehicle);
      if (state.harnessStyle) props['Harness Style']       = displayLabel('harnessStyle', state.harnessStyle);
      props['Air Conditioning']       = state.transmission === 'zf' ? 'Included — ZF standard' : (hasAc      ? 'Yes' : 'No');
      props['Cruise Control']         = state.transmission === 'zf' ? 'Included — ZF standard' : (hasCruise  ? 'Yes' : 'No');
      props['Factory Dash Retention'] = state.transmission === 'zf' ? 'Via CANBarra (ZF)'      : (hasCluster ? 'Yes' : 'No');
      /* Aftermarket Dash: only include when the section was visible (cluster not on) */
      if (!hasCluster) {
        props['Aftermarket Dash'] = (state.dashProvision === true) ? 'Yes' : 'No';
        if (state.dashProvision === true && state.dashModel) {
          props['Aftermarket Dash Model'] = state.dashModel;
        }
      }
      props['OBD Extension'] = hasObd ? 'Yes' : 'No';
      if (state.transmission) props['Transmission Type'] = displayLabel('transmission', state.transmission);
      if (state.transmission === 'zf') props['ZF Body Loom'] = 'Customer to supply — must be sent to GBS before harness can be built';
      if (state.ecu)          props['ECU Option']        = displayLabel('ecu',          state.ecu);
      /* Internal engine ref (prefixed _ = hidden from customer cart display) */
      if (state.engine)       props['_Engine Series']    = displayLabel('engine',       state.engine);

    } else if (isSohcHarness) {
      var sInfo      = state.sohcVehicleInfo || {};
      var engLabel   = state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? SOHC_COMPAT[state.sohcEngine].label : (state.sohcEngine || '');
      var vehStr     = state.sohcEngine === 'other-sohc'
        ? ((sInfo.vehicleMake || '') + ' ' + (sInfo.vehicleModel || '')).trim()
        : engLabel;
      props['Conversion Type']  = 'SOHC Barra ECU';
      if (vehStr)                     props['Vehicle']              = vehStr;
      if (sInfo.vehicleYear)          props['Year']                 = sInfo.vehicleYear;
      if (state.sohcTransmission)     props['Transmission']         = displayLabel('sohcTransmission', state.sohcTransmission);
      if (state.harnessStyle)         props['Loom Style']           = displayLabel('harnessStyle',     state.harnessStyle);
      var hasObdSohc = state.features.indexOf('obd') !== -1;
      props['OBD Extension']          = hasObdSohc ? 'Yes' : 'No';
      props['Aftermarket Dash']       = (state.dashProvision === true) ? 'Yes' : 'No';
      if (state.dashProvision === true && state.dashModel) {
        props['Aftermarket Dash Model'] = state.dashModel;
      }

    } else if (key === 'canbarra') {
      if (state.canbarraInfo.vehicleMakeModel) props['Vehicle Make and Model'] = state.canbarraInfo.vehicleMakeModel;
      if (state.canbarraInfo.year)             props['Vehicle Year']           = state.canbarraInfo.year;
      if (state.canbarraInfo.originalEngine)   props['Factory Engine']         = state.canbarraInfo.originalEngine;
      if (state.transmission)                  props['Factory Transmission']   = displayLabel('transmission', state.transmission);
      if (harnessTitle)                        props['Recommended With Loom']  = harnessTitle;

    } else if (key === 'aftermarketDash') {
      if (state.dashModel) props['Dash Model'] = state.dashModel;
    }

    return props;
  }

  /* ================================================================
     CART INTERACTION  (6-cyl only)
  ================================================================ */
  function bindResultsListeners() {
    if (!resultsEl) return;
    resultsEl.querySelectorAll('.gbs-rec-card__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.gbs-rec-card');
        if (card) setItemRemoved(card.getAttribute('data-key'), true);
      });
    });
    resultsEl.querySelectorAll('.gbs-rec-card__readd').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.gbs-rec-card');
        if (card) setItemRemoved(card.getAttribute('data-key'), false);
      });
    });
    var atcBtn = document.getElementById('gbsAtcBtn');
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
  }

  function setItemRemoved(key, removed) {
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].key === key) { cartItems[i].removed = removed; break; }
    }
    var card = document.getElementById('gbsRec-' + key);
    if (card) {
      if (removed) card.classList.add('is-removed');
      else         card.classList.remove('is-removed');
    }
    updateAtcCount();
  }

  function updateAtcCount() {
    var selected = cartItems.filter(function (i) { return !i.removed; });
    var n = selected.length;
    var countEl = document.getElementById('gbsAtcCount');
    if (countEl) countEl.textContent = n + ' item' + (n !== 1 ? 's' : '') + ' selected';
    var atcBtn = document.getElementById('gbsAtcBtn');
    if (!atcBtn) return;
    if (n === 0) { atcBtn.disabled = true;  atcBtn.textContent = 'No items selected'; }
    else         { atcBtn.disabled = false; atcBtn.textContent = 'Add ' + n + ' Item' + (n !== 1 ? 's' : '') + ' To Cart'; }
  }

  function addToCart() {
    var atcBtn   = document.getElementById('gbsAtcBtn');
    /* Prevent double-click / double-submission */
    if (atcBtn && atcBtn.disabled) return;

    var selected = cartItems.filter(function (i) { return !i.removed; });
    if (selected.length === 0) return;

    /* Find harness title for "Recommended With Loom" property on CANBarra line */
    var harnessTitle = '';
    selected.forEach(function (item) {
      if (item.key === 'standaloneHarness' || item.key === 'integrationHarness' ||
          item.key === 'sohcHarnessStandalone' || item.key === 'sohcHarnessIntegration') {
        var p = PRODUCTS[item.key];
        if (p) harnessTitle = p._shopifyTitle || p.title;
      }
    });

    var items    = [];
    var notReady = [];

    /* For ZF builds, CANBarra is mandatory — force it into selected even if removed */
    if (state.transmission === 'zf') {
      var hasCb = selected.some(function (i) { return i.key === 'canbarra'; });
      if (!hasCb) {
        selected = selected.concat([{ key: 'canbarra', qty: 1, removed: false }]);
      }
    }

    selected.forEach(function (item) {
      var variant = pickVariant(item.key);
      if (!variant) { var p = PRODUCTS[item.key]; notReady.push(p ? p.title : item.key); return; }
      var props    = buildItemProperties(item.key, harnessTitle);
      var cartItem = { id: variant.id, quantity: item.qty || 1 };
      if (Object.keys(props).length > 0) cartItem.properties = props;
      items.push(cartItem);
    });

    if (items.length === 0) {
      showAtcMessage('error', 'Unable to load product data. Please <a href="/pages/contact">contact us</a> to place your order.');
      return;
    }

    var originalText   = atcBtn.textContent;
    atcBtn.disabled    = true;
    atcBtn.textContent = 'Adding to cart…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (res) { if (!res.ok) { return res.json().then(function (d) { throw d; }); } return res.json(); })
    .then(function () {
      atcBtn.textContent = 'Added — opening cart…';
      if (notReady.length > 0) {
        showAtcMessage('info', items.length + ' item' + (items.length !== 1 ? 's' : '') + ' added. Note: ' + notReady.join(', ') + ' could not be added automatically — please contact us.');
      }

      if (state.engineFamily === 'sohc-barra-ecu') {
        var sInfo = state.sohcVehicleInfo || {};
        var sObd  = state.features.indexOf('obd') !== -1;
        var engineLabel = state.sohcEngine && SOHC_COMPAT[state.sohcEngine] ? SOHC_COMPAT[state.sohcEngine].label : (state.sohcEngine || '');
        var vehicleStr = state.sohcEngine === 'other-sohc'
          ? ((sInfo.vehicleMake || '') + ' ' + (sInfo.vehicleModel || '')).trim()
          : engineLabel;
        var retains = [];
        if (sInfo.clusterRetain) retains.push('Instrument Cluster');
        if (sInfo.acRetain)      retains.push('Air Conditioning');
        if (sInfo.cruiseRetain)  retains.push('Cruise Control');
        var sAttrs = {
          'GBS Builder - Conversion Type':  'SOHC Barra ECU Conversion',
          'GBS Builder - SOHC Engine':      engineLabel,
          'GBS Builder - Vehicle':          vehicleStr,
          'GBS Builder - Year':             sInfo.vehicleYear   || '',
          'GBS Builder - Transmission':     displayLabel('sohcTransmission', state.sohcTransmission) || '',
          'GBS Builder - Loom Style':       displayLabel('harnessStyle',     state.harnessStyle)     || '',
          'GBS Builder - ECU Service':      displayLabel('ecu',              state.ecu)              || '',
          'GBS Builder - ECU Generation':   displayLabel('sohcEcuGen',       state.sohcEcuGen)       || '',
          'GBS Builder - OBDII Port':       sObd ? 'Extended Into Cabin (+$25)' : 'Standard Location'
        };
        if (retains.length)      sAttrs['GBS Builder - Retain']      = retains.join(', ');
        sAttrs['GBS Builder - Aftermarket Dash'] = state.dashProvision === true ? (state.dashModel ? state.dashModel + ' (+$25)' : 'Yes (+$25)') : 'None';
        if (sInfo.ecuDetails)    sAttrs['ECU Part Number / Catch Code'] = sInfo.ecuDetails;
        if (state.sohcEcuInfo)   sAttrs['ECU Generation Notes']      = state.sohcEcuInfo;
        if (sInfo.originalEngine && state.sohcEngine === 'other-sohc') sAttrs['SOHC Engine Description'] = sInfo.originalEngine;
        if (sInfo.notes)         sAttrs['Customer Notes']            = sInfo.notes;
        var sNote =
          'SOHC Barra ECU Conversion\n' +
          'Engine:       ' + engineLabel + '\n' +
          'Vehicle:      ' + vehicleStr  + '\n' +
          'Year:         ' + (sInfo.vehicleYear || '') + '\n' +
          'Transmission: ' + (displayLabel('sohcTransmission', state.sohcTransmission) || '') + '\n' +
          'Loom Style:   ' + (displayLabel('harnessStyle',     state.harnessStyle)     || '') + '\n' +
          'ECU Service:  ' + (displayLabel('ecu',              state.ecu)              || '') + '\n' +
          'ECU Gen:      ' + (displayLabel('sohcEcuGen',       state.sohcEcuGen)       || '') + '\n' +
          'OBDII Port:   ' + (sObd ? 'Extended Into Cabin (+$25)' : 'Standard Location');
        if (retains.length)     sNote += '\nRetain: ' + retains.join(', ');
        sNote += '\nDash Provision: ' + (state.dashProvision === true ? (state.dashModel ? state.dashModel + ' (+$25)' : 'Yes (+$25)') : 'None');
        if (state.sohcEcuInfo)  sNote += '\nECU Notes: ' + state.sohcEcuInfo;
        if (sInfo.notes)        sNote += '\nCustomer Notes: ' + sInfo.notes;
        fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ attributes: sAttrs, note: sNote })
        }).then(function () { setTimeout(openCartDrawer, 300); })
          .catch(function () { setTimeout(openCartDrawer, 300); });
        return;
      }

      var hasCluster    = state.features.indexOf('cluster') !== -1;
      var hasAc         = state.features.indexOf('ac')      !== -1;
      var hasObd        = state.features.indexOf('obd')     !== -1;
      var needsCanbarra = hasAc || hasCluster || state.transmission === 'zf';

      var attrs = {
        'GBS Builder - Engine Family': displayFamilyLabel(state.engineFamily) || '',
        'GBS Builder - Vehicle':       displayLabel('vehicle',      state.vehicle)      || '',
        'GBS Builder - Engine':        displayLabel('engine',       state.engine)       || '',
        'GBS Builder - Transmission':  displayLabel('transmission', state.transmission) || '',
        'GBS Builder - Harness':       displayLabel('harnessStyle', state.harnessStyle) || '',
        'GBS Builder - ECU':           displayLabel('ecu',          state.ecu)          || '',
        'GBS Builder - OBDII Port':    hasObd ? 'Extended into Cabin (+$25)' : 'Standard Location',
        'GBS Builder - Aftermarket Dash': state.dashProvision === true ? (state.dashModel ? state.dashModel + ' (+$25)' : 'Yes (+$25)') : 'None',
        'GBS Builder - Features':      featLabel()
      };
      if (hasCluster) {
        attrs['Cluster Retention'] = 'Requested — Requires Team Review';
        attrs['Cluster Type']      = state.clusterInfo.clusterType || 'Not provided';
        attrs['Cluster Notes']     = state.clusterInfo.notes       || '';
      }
      if (needsCanbarra) {
        attrs['CANBarra - Vehicle Year']    = state.canbarraInfo.year           || 'Not provided';
        attrs['CANBarra - Original Engine'] = state.canbarraInfo.originalEngine || 'Not provided';
      }
      if (state.transmission === 'zf') {
        attrs['ZF Body Loom'] = 'Customer to supply — must be sent to GBS before harness can be built';
      }

      var note =
        'Barra Builder Configuration\n' +
        'Engine Family: ' + (displayFamilyLabel(state.engineFamily) || '') + '\n' +
        'Vehicle:       ' + (displayLabel('vehicle',      state.vehicle)      || '') + '\n' +
        'Engine:        ' + (displayLabel('engine',       state.engine)       || '') + '\n' +
        'Transmission:  ' + (displayLabel('transmission', state.transmission) || '') + '\n' +
        'Harness:       ' + (displayLabel('harnessStyle', state.harnessStyle) || '') + '\n' +
        'ECU:           ' + (displayLabel('ecu',          state.ecu)          || '') + '\n' +
        'OBDII Port:    ' + (hasObd ? 'Extended into Cabin (+$25)' : 'Standard Location') + '\n' +
        'Features:      ' + featLabel();
      note += '\nDash Provision: ' + (state.dashProvision === true ? (state.dashModel ? state.dashModel + ' (+$25)' : 'Yes (+$25)') : 'None');
      if (hasCluster) {
        note += '\n\nCluster Retention: Requested — Requires Team Review' +
          '\nCluster Type: ' + (state.clusterInfo.clusterType || 'Not provided');
        if (state.clusterInfo.notes) note += '\nNotes: ' + state.clusterInfo.notes;
      }
      if (needsCanbarra) {
        note += '\n\nCANBarra Configuration:\nVehicle Year: ' + (state.canbarraInfo.year || 'Not provided') +
          '\nOriginal Engine: ' + (state.canbarraInfo.originalEngine || 'Not provided');
      }
      if (state.transmission === 'zf') {
        note += '\n\nZF Automatic: Customer must supply their own ZF body loom — it must be sent to us before we can build the harness.';
      }

      fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ attributes: attrs, note: note })
      }).then(function () { setTimeout(openCartDrawer, 300); })
        .catch(function () { setTimeout(openCartDrawer, 300); });
    })
    .catch(function (err) {
      console.error('GBS Builder ATC error:', err);
      atcBtn.disabled    = false;
      atcBtn.textContent = originalText;
      var msg = (err && err.description) ? err.description : 'Something went wrong adding items to cart. Please try again or <a href="/pages/contact">contact us</a>.';
      showAtcMessage('error', msg);
    });
  }

  function openCartDrawer() {
    var cartBtn = document.querySelector('[aria-controls="cart-drawer"]');
    if (cartBtn) { cartBtn.click(); return; }
    window.location.href = '/cart';
  }

  function showAtcMessage(type, htmlMsg) {
    var section = document.getElementById('gbsAtcSection');
    if (!section) return;
    var old = section.querySelector('.gbs-atc-msg');
    if (old) old.remove();
    var el = document.createElement('p');
    el.className = 'gbs-atc-msg gbs-atc-msg--' + type;
    el.innerHTML = htmlMsg;
    section.insertBefore(el, section.querySelector('.gbs-atc-note') || null);
    if (type === 'info') setTimeout(function () { if (el.parentNode) el.remove(); }, 8000);
  }

  /* ================================================================
     RESET
  ================================================================ */
  function reset() {
    state.engineFamily = null; state.vehicle = null; state.engine = null;
    state.bossVariant = null; state.transmission = null; state.harnessStyle = null;
    state.ecu = null; state.sohcEngine = null; state.sohcEcuGen = null; state.sohcEcuInfo = '';
    state.sohcTransmission = null;
    state.sohcVehicleInfo = { vehicleMake: '', vehicleModel: '', vehicleYear: '', originalEngine: '', ecuDetails: '', clusterRetain: false, acRetain: false, cruiseRetain: false, notes: '' };
    state.features = [];
    state.clusterInfo  = { clusterType: '', notes: '' };
    state.canbarraInfo = { vehicleMakeModel: '', year: '', originalEngine: '' };
    state.dashProvision = null; state.dashModel = '';
    cartItems = [];
    ACTIVE_STEPS = []; ACTIVE_STATE_KEYS = []; ACTIVE_STEP_LABELS = []; TOTAL_STEPS = 0;
    activeStep = 1;
    stepsEl.innerHTML = '';
    if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.hidden = true; }
    if (restartEl)   restartEl.hidden = true;
    if (progressEl) { progressEl.hidden = true; progressEl.innerHTML = ''; }
    familyCardEl = null;
    appendFamilyStep();
    if (progressEl) progressEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else if (stepsEl) stepsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ================================================================
     UTILITY
  ================================================================ */
  function esc(str) {
    if (!str) return '';
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

}());
